"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftControllerListShiftsSortEnum = exports.ShiftControllerListShiftsShiftTypeEnum = exports.ShiftControllerListShiftsStatusEnum = exports.SearchControllerFindAvailableShiftsSortEnum = exports.SearchControllerFindAvailableOrientationsSortEnum = exports.PayrollControllerGetPaychecksStatusEnum = exports.NurseControllerListShiftsSortEnum = exports.NurseControllerListOrientationsSortEnum = exports.FacilityControllerShiftCalendarSortEnum = exports.FacilityControllerOrientationCalendarSortEnum = exports.FacilityControllerListShiftsSortEnum = exports.FacilityControllerListShiftsShiftTypeEnum = exports.FacilityControllerListShiftsShiftTimesEnum = exports.FacilityControllerListShiftsStatusEnum = exports.FacilityControllerListOrientationsSortEnum = exports.FacilityControllerListOrientationsStatusEnum = exports.DefaultApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class DefaultApi extends runtime.BaseAPI {
    /**
     */
    async accountControllerBlockAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling accountControllerBlockAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/block/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async accountControllerBlockAccount(requestParameters, initOverrides) {
        await this.accountControllerBlockAccountRaw(requestParameters, initOverrides);
    }
    /**
     */
    async accountControllerDeleteAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError('email', 'Required parameter "email" was null or undefined when calling accountControllerDeleteAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/deactivate/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async accountControllerDeleteAccount(requestParameters, initOverrides) {
        await this.accountControllerDeleteAccountRaw(requestParameters, initOverrides);
    }
    /**
     */
    async accountControllerRegisterFacilityAdministratorAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['registerFacilityAdministratorAccountDto'] == null) {
            throw new runtime.RequiredError('registerFacilityAdministratorAccountDto', 'Required parameter "registerFacilityAdministratorAccountDto" was null or undefined when calling accountControllerRegisterFacilityAdministratorAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/facility-admin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegisterFacilityAdministratorAccountDtoToJSON)(requestParameters['registerFacilityAdministratorAccountDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async accountControllerRegisterFacilityAdministratorAccount(requestParameters, initOverrides) {
        const response = await this.accountControllerRegisterFacilityAdministratorAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async accountControllerRegisterNurseAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['registerNurseAccountDto'] == null) {
            throw new runtime.RequiredError('registerNurseAccountDto', 'Required parameter "registerNurseAccountDto" was null or undefined when calling accountControllerRegisterNurseAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/nurse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegisterNurseAccountDtoToJSON)(requestParameters['registerNurseAccountDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async accountControllerRegisterNurseAccount(requestParameters, initOverrides) {
        const response = await this.accountControllerRegisterNurseAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async accountControllerRegisterPlatformAdministratorAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['registerPlatformAdministratorAccountDto'] == null) {
            throw new runtime.RequiredError('registerPlatformAdministratorAccountDto', 'Required parameter "registerPlatformAdministratorAccountDto" was null or undefined when calling accountControllerRegisterPlatformAdministratorAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/platform-administrator`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegisterPlatformAdministratorAccountDtoToJSON)(requestParameters['registerPlatformAdministratorAccountDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async accountControllerRegisterPlatformAdministratorAccount(requestParameters, initOverrides) {
        const response = await this.accountControllerRegisterPlatformAdministratorAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async accountControllerUnblockAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling accountControllerUnblockAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/unblock/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async accountControllerUnblockAccount(requestParameters, initOverrides) {
        await this.accountControllerUnblockAccountRaw(requestParameters, initOverrides);
    }
    /**
     */
    async accountControllerV2RegisterNurseAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['registerNurseAccountV2Dto'] == null) {
            throw new runtime.RequiredError('registerNurseAccountV2Dto', 'Required parameter "registerNurseAccountV2Dto" was null or undefined when calling accountControllerV2RegisterNurseAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/account/nurse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegisterNurseAccountV2DtoToJSON)(requestParameters['registerNurseAccountV2Dto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async accountControllerV2RegisterNurseAccount(requestParameters, initOverrides) {
        const response = await this.accountControllerV2RegisterNurseAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async addressDistanceControllerCalculateDistancesRaw(requestParameters, initOverrides) {
        if (requestParameters['calculateDistancesDto'] == null) {
            throw new runtime.RequiredError('calculateDistancesDto', 'Required parameter "calculateDistancesDto" was null or undefined when calling addressDistanceControllerCalculateDistances().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/address-distance/calculate-batch`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CalculateDistancesDtoToJSON)(requestParameters['calculateDistancesDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.DistanceResultDtoFromJSON));
    }
    /**
     */
    async addressDistanceControllerCalculateDistances(requestParameters, initOverrides) {
        const response = await this.addressDistanceControllerCalculateDistancesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async adminControllerFastTrackProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling adminControllerFastTrackProfile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/{profileId}/fast-track`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async adminControllerFastTrackProfile(requestParameters, initOverrides) {
        await this.adminControllerFastTrackProfileRaw(requestParameters, initOverrides);
    }
    /**
     */
    async adminControllerGetAdminLinksRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/links`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.AdminLinkDtoFromJSON));
    }
    /**
     */
    async adminControllerGetAdminLinks(initOverrides) {
        const response = await this.adminControllerGetAdminLinksRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async alertControllerDismissAlertRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling alertControllerDismissAlert().');
        }
        if (requestParameters['dismissAlertDto'] == null) {
            throw new runtime.RequiredError('dismissAlertDto', 'Required parameter "dismissAlertDto" was null or undefined when calling alertControllerDismissAlert().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/alert/{profileId}/dismiss`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.DismissAlertDtoToJSON)(requestParameters['dismissAlertDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async alertControllerDismissAlert(requestParameters, initOverrides) {
        await this.alertControllerDismissAlertRaw(requestParameters, initOverrides);
    }
    /**
     */
    async assessmentsControllerAssignAssessmentsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling assessmentsControllerAssignAssessments().');
        }
        if (requestParameters['assignAssessmentDto'] == null) {
            throw new runtime.RequiredError('assignAssessmentDto', 'Required parameter "assignAssessmentDto" was null or undefined when calling assessmentsControllerAssignAssessments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/assessments/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.AssignAssessmentDtoToJSON)(requestParameters['assignAssessmentDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async assessmentsControllerAssignAssessments(requestParameters, initOverrides) {
        await this.assessmentsControllerAssignAssessmentsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async assessmentsControllerAssignRegulatoryAssessmentsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling assessmentsControllerAssignRegulatoryAssessments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/assessments/{profileId}/regulatory`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async assessmentsControllerAssignRegulatoryAssessments(requestParameters, initOverrides) {
        const response = await this.assessmentsControllerAssignRegulatoryAssessmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async assessmentsControllerGetRegulatoryAssessmentsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling assessmentsControllerGetRegulatoryAssessments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/assessments/{profileId}/regulatory`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async assessmentsControllerGetRegulatoryAssessments(requestParameters, initOverrides) {
        const response = await this.assessmentsControllerGetRegulatoryAssessmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async assessmentsControllerResetAssessmentsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling assessmentsControllerResetAssessments().');
        }
        if (requestParameters['resetAssessmentsDto'] == null) {
            throw new runtime.RequiredError('resetAssessmentsDto', 'Required parameter "resetAssessmentsDto" was null or undefined when calling assessmentsControllerResetAssessments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/assessments/{profileId}/reset`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ResetAssessmentsDtoToJSON)(requestParameters['resetAssessmentsDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async assessmentsControllerResetAssessments(requestParameters, initOverrides) {
        await this.assessmentsControllerResetAssessmentsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async assessmentsControllerSyncReliasRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling assessmentsControllerSyncRelias().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/assessments/{profileId}/sync`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async assessmentsControllerSyncRelias(requestParameters, initOverrides) {
        await this.assessmentsControllerSyncReliasRaw(requestParameters, initOverrides);
    }
    /**
     */
    async auditControllerGetHistoryRaw(requestParameters, initOverrides) {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError('entityType', 'Required parameter "entityType" was null or undefined when calling auditControllerGetHistory().');
        }
        if (requestParameters['entityId'] == null) {
            throw new runtime.RequiredError('entityId', 'Required parameter "entityId" was null or undefined when calling auditControllerGetHistory().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/audit/history/{entityType}/{entityId}`.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType']))).replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters['entityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.AuditLogDtoFromJSON));
    }
    /**
     */
    async auditControllerGetHistory(requestParameters, initOverrides) {
        const response = await this.auditControllerGetHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async backgroundCheckControllerCancelBackgroundCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['cancelBackgroundCheckDto'] == null) {
            throw new runtime.RequiredError('cancelBackgroundCheckDto', 'Required parameter "cancelBackgroundCheckDto" was null or undefined when calling backgroundCheckControllerCancelBackgroundCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CancelBackgroundCheckDtoToJSON)(requestParameters['cancelBackgroundCheckDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async backgroundCheckControllerCancelBackgroundCheck(requestParameters, initOverrides) {
        await this.backgroundCheckControllerCancelBackgroundCheckRaw(requestParameters, initOverrides);
    }
    /**
     */
    async backgroundCheckControllerGetBackgroundCheckStatusRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling backgroundCheckControllerGetBackgroundCheckStatus().');
        }
        const queryParameters = {};
        if (requestParameters['packageId'] != null) {
            queryParameters['packageId'] = requestParameters['packageId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check/profile/{profileId}/status`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.BackgroundCheckStatusDtoFromJSON)(jsonValue));
    }
    /**
     */
    async backgroundCheckControllerGetBackgroundCheckStatus(requestParameters, initOverrides) {
        const response = await this.backgroundCheckControllerGetBackgroundCheckStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async backgroundCheckControllerGetBackgroundChecksRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling backgroundCheckControllerGetBackgroundChecks().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.BackgroundCheckDtoFromJSON));
    }
    /**
     */
    async backgroundCheckControllerGetBackgroundChecks(requestParameters, initOverrides) {
        const response = await this.backgroundCheckControllerGetBackgroundChecksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async backgroundCheckControllerSubmitBackgroundCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['submitBackgroundCheckDto'] == null) {
            throw new runtime.RequiredError('submitBackgroundCheckDto', 'Required parameter "submitBackgroundCheckDto" was null or undefined when calling backgroundCheckControllerSubmitBackgroundCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SubmitBackgroundCheckDtoToJSON)(requestParameters['submitBackgroundCheckDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.BackgroundCheckStatusDtoFromJSON)(jsonValue));
    }
    /**
     */
    async backgroundCheckControllerSubmitBackgroundCheck(requestParameters, initOverrides) {
        const response = await this.backgroundCheckControllerSubmitBackgroundCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async backgroundCheckControllerSyncBackgroundCheckStatusRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling backgroundCheckControllerSyncBackgroundCheckStatus().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.BackgroundCheckStatusDtoFromJSON));
    }
    /**
     */
    async backgroundCheckControllerSyncBackgroundCheckStatus(requestParameters, initOverrides) {
        const response = await this.backgroundCheckControllerSyncBackgroundCheckStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async backgroundCheckPackageControllerGetPackagesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['packageId'] != null) {
            queryParameters['packageId'] = requestParameters['packageId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check-packages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.BackgroundCheckPackageDtoFromJSON));
    }
    /**
     */
    async backgroundCheckPackageControllerGetPackages(requestParameters = {}, initOverrides) {
        const response = await this.backgroundCheckPackageControllerGetPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async billingControllerGetFeesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/fees`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.BillingFeesDtoFromJSON)(jsonValue));
    }
    /**
     */
    async billingControllerGetFees(requestParameters = {}, initOverrides) {
        const response = await this.billingControllerGetFeesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async billingInvoiceControllerGenerateFacilityInvoicesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling billingInvoiceControllerGenerateFacilityInvoices().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-invoice/facilities/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async billingInvoiceControllerGenerateFacilityInvoices(requestParameters, initOverrides) {
        const response = await this.billingInvoiceControllerGenerateFacilityInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async billingInvoiceControllerGetInvoiceableFaciltiesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-invoice/facilities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async billingInvoiceControllerGetInvoiceableFacilties(initOverrides) {
        const response = await this.billingInvoiceControllerGetInvoiceableFaciltiesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async billingInvoiceControllerGetInvoicesRaw(requestParameters, initOverrides) {
        if (requestParameters['payPeriodStart'] == null) {
            throw new runtime.RequiredError('payPeriodStart', 'Required parameter "payPeriodStart" was null or undefined when calling billingInvoiceControllerGetInvoices().');
        }
        if (requestParameters['payPeriodEnd'] == null) {
            throw new runtime.RequiredError('payPeriodEnd', 'Required parameter "payPeriodEnd" was null or undefined when calling billingInvoiceControllerGetInvoices().');
        }
        const queryParameters = {};
        if (requestParameters['payPeriodStart'] != null) {
            queryParameters['payPeriodStart'] = requestParameters['payPeriodStart'];
        }
        if (requestParameters['payPeriodEnd'] != null) {
            queryParameters['payPeriodEnd'] = requestParameters['payPeriodEnd'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-invoice/invoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.InvoiceDtoFromJSON));
    }
    /**
     */
    async billingInvoiceControllerGetInvoices(requestParameters, initOverrides) {
        const response = await this.billingInvoiceControllerGetInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async certificationControllerDeleteCertificationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerDeleteCertification().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling certificationControllerDeleteCertification().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/certification/{profileId}/{code}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async certificationControllerDeleteCertification(requestParameters, initOverrides) {
        await this.certificationControllerDeleteCertificationRaw(requestParameters, initOverrides);
    }
    /**
     */
    async certificationControllerGetCertificationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerGetCertification().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling certificationControllerGetCertification().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/certification/{profileId}/{code}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CertificationDtoFromJSON)(jsonValue));
    }
    /**
     */
    async certificationControllerGetCertification(requestParameters, initOverrides) {
        const response = await this.certificationControllerGetCertificationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async certificationControllerGetCertificationsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerGetCertifications().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/certification/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.CertificationDtoFromJSON));
    }
    /**
     */
    async certificationControllerGetCertifications(requestParameters, initOverrides) {
        const response = await this.certificationControllerGetCertificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async certificationControllerSetVerificationStatusRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerSetVerificationStatus().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling certificationControllerSetVerificationStatus().');
        }
        if (requestParameters['status'] == null) {
            throw new runtime.RequiredError('status', 'Required parameter "status" was null or undefined when calling certificationControllerSetVerificationStatus().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/certification/{profileId}/{code}/status/{status}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))).replace(`{${"status"}}`, encodeURIComponent(String(requestParameters['status']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async certificationControllerSetVerificationStatus(requestParameters, initOverrides) {
        await this.certificationControllerSetVerificationStatusRaw(requestParameters, initOverrides);
    }
    /**
     */
    async certificationControllerUpdateCertificationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerUpdateCertification().');
        }
        if (requestParameters['certificationDto'] == null) {
            throw new runtime.RequiredError('certificationDto', 'Required parameter "certificationDto" was null or undefined when calling certificationControllerUpdateCertification().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/certification/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CertificationDtoToJSON)(requestParameters['certificationDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async certificationControllerUpdateCertification(requestParameters, initOverrides) {
        await this.certificationControllerUpdateCertificationRaw(requestParameters, initOverrides);
    }
    /**
     */
    async certificationControllerUploadCertificationCardRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerUploadCertificationCard().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling certificationControllerUploadCertificationCard().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['certificationCard'] != null) {
            formParams.append('certificationCard', requestParameters['certificationCard']);
        }
        const response = await this.request({
            path: `/certification/{profileId}/{code}/certification-card`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async certificationControllerUploadCertificationCard(requestParameters, initOverrides) {
        await this.certificationControllerUploadCertificationCardRaw(requestParameters, initOverrides);
    }
    /**
     */
    async credentialsCheckControllerGetProfilesWithExpiredCredentialsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['expiredAfter'] != null) {
            queryParameters['expiredAfter'] = requestParameters['expiredAfter'].toISOString();
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/credentials-check/profiles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async credentialsCheckControllerGetProfilesWithExpiredCredentials(requestParameters = {}, initOverrides) {
        const response = await this.credentialsCheckControllerGetProfilesWithExpiredCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async credentialsCheckControllerNotifyNurseOfExpiredCredentialsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling credentialsCheckControllerNotifyNurseOfExpiredCredentials().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/credentials-check/profiles/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async credentialsCheckControllerNotifyNurseOfExpiredCredentials(requestParameters, initOverrides) {
        await this.credentialsCheckControllerNotifyNurseOfExpiredCredentialsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async credentialsCheckControllerValidateUpcomingShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['validateUpcomingShiftsDto'] == null) {
            throw new runtime.RequiredError('validateUpcomingShiftsDto', 'Required parameter "validateUpcomingShiftsDto" was null or undefined when calling credentialsCheckControllerValidateUpcomingShifts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/credentials-check/validate-upcoming-shifts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ValidateUpcomingShiftsDtoToJSON)(requestParameters['validateUpcomingShiftsDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ValidateUpcomingShiftsResultDtoFromJSON)(jsonValue));
    }
    /**
     */
    async credentialsCheckControllerValidateUpcomingShifts(requestParameters, initOverrides) {
        const response = await this.credentialsCheckControllerValidateUpcomingShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async dhsBackgroundCheckControllerGetDhsBackgroundCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerGetDhsBackgroundCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.DhsBackgroundCheckStatusDtoFromJSON)(jsonValue));
    }
    /**
     */
    async dhsBackgroundCheckControllerGetDhsBackgroundCheck(requestParameters, initOverrides) {
        const response = await this.dhsBackgroundCheckControllerGetDhsBackgroundCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async dhsBackgroundCheckControllerGetDhsDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerGetDhsDocument().');
        }
        if (requestParameters['documentType'] == null) {
            throw new runtime.RequiredError('documentType', 'Required parameter "documentType" was null or undefined when calling dhsBackgroundCheckControllerGetDhsDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}/{documentType}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"documentType"}}`, encodeURIComponent(String(requestParameters['documentType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.StoredDocumentDtoFromJSON)(jsonValue));
    }
    /**
     */
    async dhsBackgroundCheckControllerGetDhsDocument(requestParameters, initOverrides) {
        const response = await this.dhsBackgroundCheckControllerGetDhsDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async dhsBackgroundCheckControllerRemoveDhsDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerRemoveDhsDocument().');
        }
        if (requestParameters['documentType'] == null) {
            throw new runtime.RequiredError('documentType', 'Required parameter "documentType" was null or undefined when calling dhsBackgroundCheckControllerRemoveDhsDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}/{documentType}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"documentType"}}`, encodeURIComponent(String(requestParameters['documentType']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async dhsBackgroundCheckControllerRemoveDhsDocument(requestParameters, initOverrides) {
        await this.dhsBackgroundCheckControllerRemoveDhsDocumentRaw(requestParameters, initOverrides);
    }
    /**
     */
    async dhsBackgroundCheckControllerRequestBackgroundCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerRequestBackgroundCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async dhsBackgroundCheckControllerRequestBackgroundCheck(requestParameters, initOverrides) {
        await this.dhsBackgroundCheckControllerRequestBackgroundCheckRaw(requestParameters, initOverrides);
    }
    /**
     */
    async dhsBackgroundCheckControllerResendBackgroundCheckEmailRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerResendBackgroundCheckEmail().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}/resend-email`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async dhsBackgroundCheckControllerResendBackgroundCheckEmail(requestParameters, initOverrides) {
        await this.dhsBackgroundCheckControllerResendBackgroundCheckEmailRaw(requestParameters, initOverrides);
    }
    /**
     */
    async dhsBackgroundCheckControllerUpdateDhsBackgroundCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerUpdateDhsBackgroundCheck().');
        }
        if (requestParameters['dhsBackgroundCheckStatusDto'] == null) {
            throw new runtime.RequiredError('dhsBackgroundCheckStatusDto', 'Required parameter "dhsBackgroundCheckStatusDto" was null or undefined when calling dhsBackgroundCheckControllerUpdateDhsBackgroundCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.DhsBackgroundCheckStatusDtoToJSON)(requestParameters['dhsBackgroundCheckStatusDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async dhsBackgroundCheckControllerUpdateDhsBackgroundCheck(requestParameters, initOverrides) {
        await this.dhsBackgroundCheckControllerUpdateDhsBackgroundCheckRaw(requestParameters, initOverrides);
    }
    /**
     */
    async dhsBackgroundCheckControllerUploadDhsDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerUploadDhsDocument().');
        }
        if (requestParameters['documentType'] == null) {
            throw new runtime.RequiredError('documentType', 'Required parameter "documentType" was null or undefined when calling dhsBackgroundCheckControllerUploadDhsDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['letter'] != null) {
            formParams.append('letter', requestParameters['letter']);
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}/{documentType}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"documentType"}}`, encodeURIComponent(String(requestParameters['documentType']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.StoredDocumentDtoFromJSON)(jsonValue));
    }
    /**
     */
    async dhsBackgroundCheckControllerUploadDhsDocument(requestParameters, initOverrides) {
        const response = await this.dhsBackgroundCheckControllerUploadDhsDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async employeeCheckEventControllerHandleEmployeeCheckEventRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/payroll/webhook/employee-check-event`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async employeeCheckEventControllerHandleEmployeeCheckEvent(initOverrides) {
        await this.employeeCheckEventControllerHandleEmployeeCheckEventRaw(initOverrides);
    }
    /**
     */
    async employeeCheckEventControllerHandleEmployerCheckProcessedLiteEventRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/payroll/webhook/employer-check-processed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async employeeCheckEventControllerHandleEmployerCheckProcessedLiteEvent(initOverrides) {
        await this.employeeCheckEventControllerHandleEmployerCheckProcessedLiteEventRaw(initOverrides);
    }
    /**
     */
    async employeeI9EventControllerHandleEmployeeI9EventRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/payroll/webhook/employee-i9-event`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async employeeI9EventControllerHandleEmployeeI9Event(initOverrides) {
        await this.employeeI9EventControllerHandleEmployeeI9EventRaw(initOverrides);
    }
    /**
     */
    async facilityControllerBlockNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerBlockNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerBlockNurse().');
        }
        const queryParameters = {};
        if (requestParameters['reason'] != null) {
            queryParameters['reason'] = requestParameters['reason'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse/{profileId}/block`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityControllerBlockNurse(requestParameters, initOverrides) {
        await this.facilityControllerBlockNurseRaw(requestParameters, initOverrides);
    }
    /**
     */
    async facilityControllerCreateFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityCreateDto'] == null) {
            throw new runtime.RequiredError('facilityCreateDto', 'Required parameter "facilityCreateDto" was null or undefined when calling facilityControllerCreateFacility().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FacilityCreateDtoToJSON)(requestParameters['facilityCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerCreateFacility(requestParameters, initOverrides) {
        const response = await this.facilityControllerCreateFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerDeactivateFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerDeactivateFacility().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityControllerDeactivateFacility(requestParameters, initOverrides) {
        await this.facilityControllerDeactivateFacilityRaw(requestParameters, initOverrides);
    }
    /**
     */
    async facilityControllerDeleteFacilityMemberRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerDeleteFacilityMember().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerDeleteFacilityMember().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/{profileId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityControllerDeleteFacilityMember(requestParameters, initOverrides) {
        await this.facilityControllerDeleteFacilityMemberRaw(requestParameters, initOverrides);
    }
    /**
     */
    async facilityControllerDeleteNurseVerificationRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerDeleteNurseVerification().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerDeleteNurseVerification().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse/{profileId}/verify`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityControllerDeleteNurseVerification(requestParameters, initOverrides) {
        await this.facilityControllerDeleteNurseVerificationRaw(requestParameters, initOverrides);
    }
    /**
     */
    async facilityControllerGetFacilitiesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityDtoFromJSON));
    }
    /**
     */
    async facilityControllerGetFacilities(requestParameters = {}, initOverrides) {
        const response = await this.facilityControllerGetFacilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerGetFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerGetFacility().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerGetFacility(requestParameters, initOverrides) {
        const response = await this.facilityControllerGetFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerGetFacilityBillingContactRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerGetFacilityBillingContact().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/billing`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.BillingContactPortalDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerGetFacilityBillingContact(requestParameters, initOverrides) {
        const response = await this.facilityControllerGetFacilityBillingContactRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerGetPendingInvitesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerGetPendingInvites().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/invite`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.InviteDtoFromJSON));
    }
    /**
     */
    async facilityControllerGetPendingInvites(requestParameters, initOverrides) {
        const response = await this.facilityControllerGetPendingInvitesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerInviteUserRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerInviteUser().');
        }
        if (requestParameters['inviteCreateDto'] == null) {
            throw new runtime.RequiredError('inviteCreateDto', 'Required parameter "inviteCreateDto" was null or undefined when calling facilityControllerInviteUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/invite`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.InviteCreateDtoToJSON)(requestParameters['inviteCreateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityControllerInviteUser(requestParameters, initOverrides) {
        await this.facilityControllerInviteUserRaw(requestParameters, initOverrides);
    }
    /**
     */
    async facilityControllerListInterestedNursesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListInterestedNurses().');
        }
        const queryParameters = {};
        if (requestParameters['excludeVerified'] != null) {
            queryParameters['excludeVerified'] = requestParameters['excludeVerified'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/interested-nurses`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityInterestedNurseDtoFromJSON));
    }
    /**
     */
    async facilityControllerListInterestedNurses(requestParameters, initOverrides) {
        const response = await this.facilityControllerListInterestedNursesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerListMembersRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListMembers().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/members`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityMemberDtoFromJSON));
    }
    /**
     */
    async facilityControllerListMembers(requestParameters, initOverrides) {
        const response = await this.facilityControllerListMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerListNursesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListNurses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityNurseDtoFromJSON));
    }
    /**
     */
    async facilityControllerListNurses(requestParameters, initOverrides) {
        const response = await this.facilityControllerListNursesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerListOrientationCountsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListOrientationCounts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/orientation/counts`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityOrientationListCountsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerListOrientationCounts(requestParameters, initOverrides) {
        const response = await this.facilityControllerListOrientationCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerListOrientationMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling facilityControllerListOrientationMatches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/orientation/{orientationId}/matches`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.OrientationMatchDtoFromJSON));
    }
    /**
     */
    async facilityControllerListOrientationMatches(requestParameters, initOverrides) {
        const response = await this.facilityControllerListOrientationMatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerListOrientationRequestsFromNursesRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling facilityControllerListOrientationRequestsFromNurses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/orientation/{orientationId}/requests`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.OrientationRequestDtoFromJSON));
    }
    /**
     */
    async facilityControllerListOrientationRequestsFromNurses(requestParameters, initOverrides) {
        const response = await this.facilityControllerListOrientationRequestsFromNursesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerListOrientationsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListOrientations().');
        }
        const queryParameters = {};
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/orientation`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfFacilityOrientationListItemDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerListOrientations(requestParameters, initOverrides) {
        const response = await this.facilityControllerListOrientationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerListShiftCountsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListShiftCounts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/shift/counts`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityShiftListCountsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerListShiftCounts(requestParameters, initOverrides) {
        const response = await this.facilityControllerListShiftCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerListShiftMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling facilityControllerListShiftMatches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/shift/{shiftId}/matches`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftMatchDtoFromJSON));
    }
    /**
     */
    async facilityControllerListShiftMatches(requestParameters, initOverrides) {
        const response = await this.facilityControllerListShiftMatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerListShiftRequestsFromNursesRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling facilityControllerListShiftRequestsFromNurses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/shift/{shiftId}/requests`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftRequestDtoFromJSON));
    }
    /**
     */
    async facilityControllerListShiftRequestsFromNurses(requestParameters, initOverrides) {
        const response = await this.facilityControllerListShiftRequestsFromNursesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerListShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListShifts().');
        }
        const queryParameters = {};
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['startDateFrom'] != null) {
            queryParameters['startDateFrom'] = requestParameters['startDateFrom'];
        }
        if (requestParameters['startDateTo'] != null) {
            queryParameters['startDateTo'] = requestParameters['startDateTo'];
        }
        if (requestParameters['createdAtFrom'] != null) {
            queryParameters['createdAtFrom'] = requestParameters['createdAtFrom'];
        }
        if (requestParameters['createdAtTo'] != null) {
            queryParameters['createdAtTo'] = requestParameters['createdAtTo'];
        }
        if (requestParameters['minCost'] != null) {
            queryParameters['minCost'] = requestParameters['minCost'];
        }
        if (requestParameters['maxCost'] != null) {
            queryParameters['maxCost'] = requestParameters['maxCost'];
        }
        if (requestParameters['claimedByProfileIds'] != null) {
            queryParameters['claimedByProfileIds'] = requestParameters['claimedByProfileIds'];
        }
        if (requestParameters['postedByProfileIds'] != null) {
            queryParameters['postedByProfileIds'] = requestParameters['postedByProfileIds'];
        }
        if (requestParameters['specialtyCodes'] != null) {
            queryParameters['specialtyCodes'] = requestParameters['specialtyCodes'];
        }
        if (requestParameters['shiftTimes'] != null) {
            queryParameters['shiftTimes'] = requestParameters['shiftTimes'];
        }
        if (requestParameters['shiftType'] != null) {
            queryParameters['shiftType'] = requestParameters['shiftType'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/shift`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfFacilityShiftListItemDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerListShifts(requestParameters, initOverrides) {
        const response = await this.facilityControllerListShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerOrientationCalendarRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerOrientationCalendar().');
        }
        const queryParameters = {};
        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/orientation/calendar`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfFacilityOrientationListItemDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerOrientationCalendar(requestParameters, initOverrides) {
        const response = await this.facilityControllerOrientationCalendarRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerPreviewOrientationMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerPreviewOrientationMatches().');
        }
        const queryParameters = {};
        if (requestParameters['specialtyCode'] != null) {
            queryParameters['specialtyCode'] = requestParameters['specialtyCode'];
        }
        if (requestParameters['stipendMinimumDistance'] != null) {
            queryParameters['stipendMinimumDistance'] = requestParameters['stipendMinimumDistance'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/orientation-matches-preview`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.OrientationMatchPreviewDtoFromJSON));
    }
    /**
     */
    async facilityControllerPreviewOrientationMatches(requestParameters, initOverrides) {
        const response = await this.facilityControllerPreviewOrientationMatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerReactivateFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerReactivateFacility().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/reactivate`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityControllerReactivateFacility(requestParameters, initOverrides) {
        await this.facilityControllerReactivateFacilityRaw(requestParameters, initOverrides);
    }
    /**
     */
    async facilityControllerShiftCalendarRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerShiftCalendar().');
        }
        const queryParameters = {};
        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/shift/calendar`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfFacilityShiftListItemDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerShiftCalendar(requestParameters, initOverrides) {
        const response = await this.facilityControllerShiftCalendarRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerUnblockNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerUnblockNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerUnblockNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse/{profileId}/block`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityControllerUnblockNurse(requestParameters, initOverrides) {
        await this.facilityControllerUnblockNurseRaw(requestParameters, initOverrides);
    }
    /**
     */
    async facilityControllerUpdateFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerUpdateFacility().');
        }
        if (requestParameters['facilityUpdateDto'] == null) {
            throw new runtime.RequiredError('facilityUpdateDto', 'Required parameter "facilityUpdateDto" was null or undefined when calling facilityControllerUpdateFacility().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FacilityUpdateDtoToJSON)(requestParameters['facilityUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerUpdateFacility(requestParameters, initOverrides) {
        const response = await this.facilityControllerUpdateFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerUpdateFacilityBillingContactRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerUpdateFacilityBillingContact().');
        }
        if (requestParameters['billingContactUpdateDto'] == null) {
            throw new runtime.RequiredError('billingContactUpdateDto', 'Required parameter "billingContactUpdateDto" was null or undefined when calling facilityControllerUpdateFacilityBillingContact().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/billing`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.BillingContactUpdateDtoToJSON)(requestParameters['billingContactUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityContactDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerUpdateFacilityBillingContact(requestParameters, initOverrides) {
        const response = await this.facilityControllerUpdateFacilityBillingContactRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerUpdatePlatformFeeRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerUpdatePlatformFee().');
        }
        if (requestParameters['facilityPlatformFeeDto'] == null) {
            throw new runtime.RequiredError('facilityPlatformFeeDto', 'Required parameter "facilityPlatformFeeDto" was null or undefined when calling facilityControllerUpdatePlatformFee().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/platform-fee`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FacilityPlatformFeeDtoToJSON)(requestParameters['facilityPlatformFeeDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityControllerUpdatePlatformFee(requestParameters, initOverrides) {
        await this.facilityControllerUpdatePlatformFeeRaw(requestParameters, initOverrides);
    }
    /**
     */
    async facilityControllerUploadFacilityPhotoRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerUploadFacilityPhoto().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['facilityPhoto'] != null) {
            formParams.append('facilityPhoto', requestParameters['facilityPhoto']);
        }
        const response = await this.request({
            path: `/facility/{facilityId}/photo`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async facilityControllerUploadFacilityPhoto(requestParameters, initOverrides) {
        const response = await this.facilityControllerUploadFacilityPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerVerifyNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerVerifyNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerVerifyNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse/{profileId}/verify`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityControllerVerifyNurse(requestParameters, initOverrides) {
        await this.facilityControllerVerifyNurseRaw(requestParameters, initOverrides);
    }
    /**
     */
    async facilityControllerViewOrientationRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling facilityControllerViewOrientation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/orientation/{orientationId}`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityOrientationDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerViewOrientation(requestParameters, initOverrides) {
        const response = await this.facilityControllerViewOrientationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityControllerViewShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling facilityControllerViewShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/shift/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityShiftDetailsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async facilityControllerViewShift(requestParameters, initOverrides) {
        const response = await this.facilityControllerViewShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create or update facility interest
     */
    async facilityInterestControllerCreateInterestRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityInterestCreateDto'] == null) {
            throw new runtime.RequiredError('facilityInterestCreateDto', 'Required parameter "facilityInterestCreateDto" was null or undefined when calling facilityInterestControllerCreateInterest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility-interests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FacilityInterestCreateDtoToJSON)(requestParameters['facilityInterestCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityInterestDtoFromJSON)(jsonValue));
    }
    /**
     * Create or update facility interest
     */
    async facilityInterestControllerCreateInterest(requestParameters, initOverrides) {
        const response = await this.facilityInterestControllerCreateInterestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityProfileDocumentControllerDeleteDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityProfileDocumentControllerDeleteDocument().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityProfileDocumentControllerDeleteDocument().');
        }
        if (requestParameters['fileName'] == null) {
            throw new runtime.RequiredError('fileName', 'Required parameter "fileName" was null or undefined when calling facilityProfileDocumentControllerDeleteDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility-profile-document/{facilityId}/{profileId}/{fileName}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters['fileName']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityProfileDocumentControllerDeleteDocument(requestParameters, initOverrides) {
        await this.facilityProfileDocumentControllerDeleteDocumentRaw(requestParameters, initOverrides);
    }
    /**
     */
    async facilityProfileDocumentControllerGetDocumentsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityProfileDocumentControllerGetDocuments().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityProfileDocumentControllerGetDocuments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility-profile-document/{facilityId}/{profileId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityProfileDocumentDtoFromJSON));
    }
    /**
     */
    async facilityProfileDocumentControllerGetDocuments(requestParameters, initOverrides) {
        const response = await this.facilityProfileDocumentControllerGetDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async facilityProfileDocumentControllerUploadDocumentsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityProfileDocumentControllerUploadDocuments().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityProfileDocumentControllerUploadDocuments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['documents'] != null) {
            requestParameters['documents'].forEach((element) => {
                formParams.append('documents', element);
            });
        }
        const response = await this.request({
            path: `/facility-profile-document/{facilityId}/{profileId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async facilityProfileDocumentControllerUploadDocuments(requestParameters, initOverrides) {
        await this.facilityProfileDocumentControllerUploadDocumentsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async featureFlagControllerDeleteFeatureFlagRaw(requestParameters, initOverrides) {
        if (requestParameters['flagKey'] == null) {
            throw new runtime.RequiredError('flagKey', 'Required parameter "flagKey" was null or undefined when calling featureFlagControllerDeleteFeatureFlag().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flag/flag/{flagKey}`.replace(`{${"flagKey"}}`, encodeURIComponent(String(requestParameters['flagKey']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async featureFlagControllerDeleteFeatureFlag(requestParameters, initOverrides) {
        await this.featureFlagControllerDeleteFeatureFlagRaw(requestParameters, initOverrides);
    }
    /**
     */
    async featureFlagControllerGetCurrentUserFeatureFlagsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flag/profile/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.UserFeatureFlagsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async featureFlagControllerGetCurrentUserFeatureFlags(initOverrides) {
        const response = await this.featureFlagControllerGetCurrentUserFeatureFlagsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async featureFlagControllerGetFeatureFlagsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flag`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FeatureFlagDtoFromJSON));
    }
    /**
     */
    async featureFlagControllerGetFeatureFlags(initOverrides) {
        const response = await this.featureFlagControllerGetFeatureFlagsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async featureFlagControllerGetUserFeatureFlagsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling featureFlagControllerGetUserFeatureFlags().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flag/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.UserFeatureFlagsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async featureFlagControllerGetUserFeatureFlags(requestParameters, initOverrides) {
        const response = await this.featureFlagControllerGetUserFeatureFlagsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async featureFlagControllerUpdateFeatureFlagRaw(requestParameters, initOverrides) {
        if (requestParameters['featureFlagUpdateDto'] == null) {
            throw new runtime.RequiredError('featureFlagUpdateDto', 'Required parameter "featureFlagUpdateDto" was null or undefined when calling featureFlagControllerUpdateFeatureFlag().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flag`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FeatureFlagUpdateDtoToJSON)(requestParameters['featureFlagUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FeatureFlagDtoFromJSON)(jsonValue));
    }
    /**
     */
    async featureFlagControllerUpdateFeatureFlag(requestParameters, initOverrides) {
        const response = await this.featureFlagControllerUpdateFeatureFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async fitTestControllerGetFitTestRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling fitTestControllerGetFitTest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fit-test/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FitTestDtoFromJSON)(jsonValue));
    }
    /**
     */
    async fitTestControllerGetFitTest(requestParameters, initOverrides) {
        const response = await this.fitTestControllerGetFitTestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async fitTestControllerUpdateFitTestRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling fitTestControllerUpdateFitTest().');
        }
        if (requestParameters['fitTestDto'] == null) {
            throw new runtime.RequiredError('fitTestDto', 'Required parameter "fitTestDto" was null or undefined when calling fitTestControllerUpdateFitTest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fit-test/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FitTestDtoToJSON)(requestParameters['fitTestDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async fitTestControllerUpdateFitTest(requestParameters, initOverrides) {
        await this.fitTestControllerUpdateFitTestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async fitTestControllerUploadDocumentationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling fitTestControllerUploadDocumentation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['documentation'] != null) {
            formParams.append('documentation', requestParameters['documentation']);
        }
        const response = await this.request({
            path: `/fit-test/{profileId}/documentation`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async fitTestControllerUploadDocumentation(requestParameters, initOverrides) {
        await this.fitTestControllerUploadDocumentationRaw(requestParameters, initOverrides);
    }
    /**
     */
    async geoControllerGetLatLngFromZipRaw(requestParameters, initOverrides) {
        if (requestParameters['zipCodeDto'] == null) {
            throw new runtime.RequiredError('zipCodeDto', 'Required parameter "zipCodeDto" was null or undefined when calling geoControllerGetLatLngFromZip().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/geo/lat-lng`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ZipCodeDtoToJSON)(requestParameters['zipCodeDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.LocationDtoFromJSON)(jsonValue));
    }
    /**
     */
    async geoControllerGetLatLngFromZip(requestParameters, initOverrides) {
        const response = await this.geoControllerGetLatLngFromZipRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async geoControllerGetZipCodeFromLatLngRaw(requestParameters, initOverrides) {
        if (requestParameters['locationDto'] == null) {
            throw new runtime.RequiredError('locationDto', 'Required parameter "locationDto" was null or undefined when calling geoControllerGetZipCodeFromLatLng().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/geo/zip`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.LocationDtoToJSON)(requestParameters['locationDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ZipCodeDtoFromJSON)(jsonValue));
    }
    /**
     */
    async geoControllerGetZipCodeFromLatLng(requestParameters, initOverrides) {
        const response = await this.geoControllerGetZipCodeFromLatLngRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async heartbeatControllerGetHeartbeatRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/heartbeat`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async heartbeatControllerGetHeartbeat(initOverrides) {
        await this.heartbeatControllerGetHeartbeatRaw(initOverrides);
    }
    /**
     */
    async hubSpotControllerHandleHubSpotWebhookRaw(requestParameters, initOverrides) {
        if (requestParameters['hubSpotPayloadDto'] == null) {
            throw new runtime.RequiredError('hubSpotPayloadDto', 'Required parameter "hubSpotPayloadDto" was null or undefined when calling hubSpotControllerHandleHubSpotWebhook().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/hubspot/signup-form/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.HubSpotPayloadDtoToJSON)(requestParameters['hubSpotPayloadDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async hubSpotControllerHandleHubSpotWebhook(requestParameters, initOverrides) {
        await this.hubSpotControllerHandleHubSpotWebhookRaw(requestParameters, initOverrides);
    }
    /**
     */
    async infectiousDiseaseTestControllerFulfillTestOrderRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerFulfillTestOrder().');
        }
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError('orderId', 'Required parameter "orderId" was null or undefined when calling infectiousDiseaseTestControllerFulfillTestOrder().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/order/{orderId}/fulfill`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.InfectiousDiseaseTestOrderDtoFromJSON)(jsonValue));
    }
    /**
     */
    async infectiousDiseaseTestControllerFulfillTestOrder(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerFulfillTestOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerGetTest().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling infectiousDiseaseTestControllerGetTest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/test/{code}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.InfectiousDiseaseTestDtoFromJSON)(jsonValue));
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTest(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerGetTestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestMinimumValidDateRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerGetTestMinimumValidDate().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling infectiousDiseaseTestControllerGetTestMinimumValidDate().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/test/{code}/min-date`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.MinimumValidDateDtoFromJSON)(jsonValue));
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestMinimumValidDate(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerGetTestMinimumValidDateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestOrderRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerGetTestOrder().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/order`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.InfectiousDiseaseTestOrderDtoFromJSON)(jsonValue));
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestOrder(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerGetTestOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerGetTests().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.InfectiousDiseaseTestDtoFromJSON));
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTests(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerGetTestsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerRequestTestOrderRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerRequestTestOrder().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/order`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async infectiousDiseaseTestControllerRequestTestOrder(requestParameters, initOverrides) {
        await this.infectiousDiseaseTestControllerRequestTestOrderRaw(requestParameters, initOverrides);
    }
    /**
     */
    async infectiousDiseaseTestControllerUpdateTestRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerUpdateTest().');
        }
        if (requestParameters['infectiousDiseaseTestUpdateDto'] == null) {
            throw new runtime.RequiredError('infectiousDiseaseTestUpdateDto', 'Required parameter "infectiousDiseaseTestUpdateDto" was null or undefined when calling infectiousDiseaseTestControllerUpdateTest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.InfectiousDiseaseTestUpdateDtoToJSON)(requestParameters['infectiousDiseaseTestUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.InfectiousDiseaseTestDtoFromJSON)(jsonValue));
    }
    /**
     */
    async infectiousDiseaseTestControllerUpdateTest(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerUpdateTestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerUploadTestCardRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerUploadTestCard().');
        }
        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError('testId', 'Required parameter "testId" was null or undefined when calling infectiousDiseaseTestControllerUploadTestCard().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['testCard'] != null) {
            formParams.append('testCard', requestParameters['testCard']);
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/test-card/{testId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"testId"}}`, encodeURIComponent(String(requestParameters['testId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async infectiousDiseaseTestControllerUploadTestCard(requestParameters, initOverrides) {
        await this.infectiousDiseaseTestControllerUploadTestCardRaw(requestParameters, initOverrides);
    }
    /**
     */
    async jurisdictionControllerCreateJurisdictionRaw(requestParameters, initOverrides) {
        if (requestParameters['jurisdictionDto'] == null) {
            throw new runtime.RequiredError('jurisdictionDto', 'Required parameter "jurisdictionDto" was null or undefined when calling jurisdictionControllerCreateJurisdiction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jurisdiction`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.JurisdictionDtoToJSON)(requestParameters['jurisdictionDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async jurisdictionControllerCreateJurisdiction(requestParameters, initOverrides) {
        await this.jurisdictionControllerCreateJurisdictionRaw(requestParameters, initOverrides);
    }
    /**
     */
    async jurisdictionControllerGetJurisdictionRaw(requestParameters, initOverrides) {
        if (requestParameters['abbreviation'] == null) {
            throw new runtime.RequiredError('abbreviation', 'Required parameter "abbreviation" was null or undefined when calling jurisdictionControllerGetJurisdiction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jurisdiction/{abbreviation}`.replace(`{${"abbreviation"}}`, encodeURIComponent(String(requestParameters['abbreviation']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.JurisdictionDetailsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async jurisdictionControllerGetJurisdiction(requestParameters, initOverrides) {
        const response = await this.jurisdictionControllerGetJurisdictionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async jurisdictionControllerListJurisdictionsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jurisdiction`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.JurisdictionDtoFromJSON));
    }
    /**
     */
    async jurisdictionControllerListJurisdictions(requestParameters = {}, initOverrides) {
        const response = await this.jurisdictionControllerListJurisdictionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async jurisdictionControllerUpdateJurisdictionRaw(requestParameters, initOverrides) {
        if (requestParameters['abbreviation'] == null) {
            throw new runtime.RequiredError('abbreviation', 'Required parameter "abbreviation" was null or undefined when calling jurisdictionControllerUpdateJurisdiction().');
        }
        if (requestParameters['jurisdictionDto'] == null) {
            throw new runtime.RequiredError('jurisdictionDto', 'Required parameter "jurisdictionDto" was null or undefined when calling jurisdictionControllerUpdateJurisdiction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jurisdiction/{abbreviation}`.replace(`{${"abbreviation"}}`, encodeURIComponent(String(requestParameters['abbreviation']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.JurisdictionDtoToJSON)(requestParameters['jurisdictionDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async jurisdictionControllerUpdateJurisdiction(requestParameters, initOverrides) {
        await this.jurisdictionControllerUpdateJurisdictionRaw(requestParameters, initOverrides);
    }
    /**
     */
    async licenseControllerGetLicensesByNcsbnIdRaw(requestParameters, initOverrides) {
        if (requestParameters['ncsbnIds'] == null) {
            throw new runtime.RequiredError('ncsbnIds', 'Required parameter "ncsbnIds" was null or undefined when calling licenseControllerGetLicensesByNcsbnId().');
        }
        const queryParameters = {};
        if (requestParameters['ncsbnIds'] != null) {
            queryParameters['ncsbnIds'] = requestParameters['ncsbnIds'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/license/nurse/by-ncsbnId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseLicenseBatchDtoFromJSON));
    }
    /**
     */
    async licenseControllerGetLicensesByNcsbnId(requestParameters, initOverrides) {
        const response = await this.licenseControllerGetLicensesByNcsbnIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async licenseControllerGetUnverifiedLicensesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/license/nurse/unverified`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseLicenseBatchDtoFromJSON));
    }
    /**
     */
    async licenseControllerGetUnverifiedLicenses(initOverrides) {
        const response = await this.licenseControllerGetUnverifiedLicensesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async licenseControllerUpdateLicenseStatusRaw(requestParameters, initOverrides) {
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError('licenseId', 'Required parameter "licenseId" was null or undefined when calling licenseControllerUpdateLicenseStatus().');
        }
        if (requestParameters['licenseStatusUpdateDto'] == null) {
            throw new runtime.RequiredError('licenseStatusUpdateDto', 'Required parameter "licenseStatusUpdateDto" was null or undefined when calling licenseControllerUpdateLicenseStatus().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/license/nurse/{licenseId}`.replace(`{${"licenseId"}}`, encodeURIComponent(String(requestParameters['licenseId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.LicenseStatusUpdateDtoToJSON)(requestParameters['licenseStatusUpdateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async licenseControllerUpdateLicenseStatus(requestParameters, initOverrides) {
        await this.licenseControllerUpdateLicenseStatusRaw(requestParameters, initOverrides);
    }
    /**
     */
    async noteControllerCreateFacilityNoteRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling noteControllerCreateFacilityNote().');
        }
        if (requestParameters['profileNoteCreateDto'] == null) {
            throw new runtime.RequiredError('profileNoteCreateDto', 'Required parameter "profileNoteCreateDto" was null or undefined when calling noteControllerCreateFacilityNote().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ProfileNoteCreateDtoToJSON)(requestParameters['profileNoteCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityNoteDtoFromJSON)(jsonValue));
    }
    /**
     */
    async noteControllerCreateFacilityNote(requestParameters, initOverrides) {
        const response = await this.noteControllerCreateFacilityNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async noteControllerCreateProfileNoteRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling noteControllerCreateProfileNote().');
        }
        if (requestParameters['profileNoteCreateDto'] == null) {
            throw new runtime.RequiredError('profileNoteCreateDto', 'Required parameter "profileNoteCreateDto" was null or undefined when calling noteControllerCreateProfileNote().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ProfileNoteCreateDtoToJSON)(requestParameters['profileNoteCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileNoteDtoFromJSON)(jsonValue));
    }
    /**
     */
    async noteControllerCreateProfileNote(requestParameters, initOverrides) {
        const response = await this.noteControllerCreateProfileNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async noteControllerDeleteAttachmentRaw(requestParameters, initOverrides) {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError('noteId', 'Required parameter "noteId" was null or undefined when calling noteControllerDeleteAttachment().');
        }
        if (requestParameters['attachmentId'] == null) {
            throw new runtime.RequiredError('attachmentId', 'Required parameter "attachmentId" was null or undefined when calling noteControllerDeleteAttachment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/{noteId}/attachments/{attachmentId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters['attachmentId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async noteControllerDeleteAttachment(requestParameters, initOverrides) {
        await this.noteControllerDeleteAttachmentRaw(requestParameters, initOverrides);
    }
    /**
     */
    async noteControllerDeleteNoteRaw(requestParameters, initOverrides) {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError('noteId', 'Required parameter "noteId" was null or undefined when calling noteControllerDeleteNote().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async noteControllerDeleteNote(requestParameters, initOverrides) {
        await this.noteControllerDeleteNoteRaw(requestParameters, initOverrides);
    }
    /**
     */
    async noteControllerGetFacilityNotesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling noteControllerGetFacilityNotes().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityNoteDtoFromJSON));
    }
    /**
     */
    async noteControllerGetFacilityNotes(requestParameters, initOverrides) {
        const response = await this.noteControllerGetFacilityNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async noteControllerGetProfileNotesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling noteControllerGetProfileNotes().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ProfileNoteDtoFromJSON));
    }
    /**
     */
    async noteControllerGetProfileNotes(requestParameters, initOverrides) {
        const response = await this.noteControllerGetProfileNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async noteControllerUpdateNoteRaw(requestParameters, initOverrides) {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError('noteId', 'Required parameter "noteId" was null or undefined when calling noteControllerUpdateNote().');
        }
        if (requestParameters['profileNoteCreateDto'] == null) {
            throw new runtime.RequiredError('profileNoteCreateDto', 'Required parameter "profileNoteCreateDto" was null or undefined when calling noteControllerUpdateNote().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ProfileNoteCreateDtoToJSON)(requestParameters['profileNoteCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileNoteDtoFromJSON)(jsonValue));
    }
    /**
     */
    async noteControllerUpdateNote(requestParameters, initOverrides) {
        const response = await this.noteControllerUpdateNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async noteControllerUploadAttachmentsRaw(requestParameters, initOverrides) {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError('noteId', 'Required parameter "noteId" was null or undefined when calling noteControllerUploadAttachments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['attachments'] != null) {
            requestParameters['attachments'].forEach((element) => {
                formParams.append('attachments', element);
            });
        }
        const response = await this.request({
            path: `/note/{noteId}/attachments`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async noteControllerUploadAttachments(requestParameters, initOverrides) {
        await this.noteControllerUploadAttachmentsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nurseControllerAcceptFacilityRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['bulkShiftAcceptDto'] == null) {
            throw new runtime.RequiredError('bulkShiftAcceptDto', 'Required parameter "bulkShiftAcceptDto" was null or undefined when calling nurseControllerAcceptFacilityRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/shifts`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.BulkShiftAcceptDtoToJSON)(requestParameters['bulkShiftAcceptDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nurseControllerAcceptFacilityRequest(requestParameters, initOverrides) {
        await this.nurseControllerAcceptFacilityRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nurseControllerCreateLicenseRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerCreateLicense().');
        }
        if (requestParameters['createNurseLicensesDto'] == null) {
            throw new runtime.RequiredError('createNurseLicensesDto', 'Required parameter "createNurseLicensesDto" was null or undefined when calling nurseControllerCreateLicense().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/license`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CreateNurseLicensesDtoToJSON)(requestParameters['createNurseLicensesDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nurseControllerCreateLicense(requestParameters, initOverrides) {
        await this.nurseControllerCreateLicenseRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nurseControllerDeleteLicenseRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerDeleteLicense().');
        }
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError('licenseId', 'Required parameter "licenseId" was null or undefined when calling nurseControllerDeleteLicense().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/license/{licenseId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"licenseId"}}`, encodeURIComponent(String(requestParameters['licenseId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nurseControllerDeleteLicense(requestParameters, initOverrides) {
        await this.nurseControllerDeleteLicenseRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nurseControllerGetActionsNeededCountsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetActionsNeededCounts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/actions-needed-counts`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ActionsNeededCountsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async nurseControllerGetActionsNeededCounts(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetActionsNeededCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerGetConfidentialityAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetConfidentialityAgreement().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/confidentiality-agreement`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ConfidentialityAgreementDtoFromJSON)(jsonValue));
    }
    /**
     */
    async nurseControllerGetConfidentialityAgreement(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetConfidentialityAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerGetContractRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetContract().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/contract`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.EmploymentContractDtoFromJSON)(jsonValue));
    }
    /**
     */
    async nurseControllerGetContract(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetContractRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerGetCurrentUserProfileCompletenessRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/me/profile-completeness`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.NurseProfileCompletenessDtoFromJSON)(jsonValue));
    }
    /**
     */
    async nurseControllerGetCurrentUserProfileCompleteness(initOverrides) {
        const response = await this.nurseControllerGetCurrentUserProfileCompletenessRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerGetLicensesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetLicenses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/license`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseLicenseDtoFromJSON));
    }
    /**
     */
    async nurseControllerGetLicenses(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetLicensesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerGetNurseEmrsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetNurseEmrs().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/emr`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ElectronicMedicalRecordSystemDtoFromJSON));
    }
    /**
     */
    async nurseControllerGetNurseEmrs(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetNurseEmrsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerGetProfileCompletenessRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetProfileCompleteness().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/profile-completeness`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.NurseProfileCompletenessDtoFromJSON)(jsonValue));
    }
    /**
     */
    async nurseControllerGetProfileCompleteness(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetProfileCompletenessRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerListOrientationsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerListOrientations().');
        }
        const queryParameters = {};
        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'].toISOString();
        }
        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'].toISOString();
        }
        if (requestParameters['requestStatus'] != null) {
            queryParameters['requestStatus'] = requestParameters['requestStatus'];
        }
        if (requestParameters['requestedBy'] != null) {
            queryParameters['requestedBy'] = requestParameters['requestedBy'];
        }
        if (requestParameters['hasTimeLogged'] != null) {
            queryParameters['hasTimeLogged'] = requestParameters['hasTimeLogged'];
        }
        if (requestParameters['isMissingTime'] != null) {
            queryParameters['isMissingTime'] = requestParameters['isMissingTime'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/orientation`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfRequestedOrientationDtoFromJSON)(jsonValue));
    }
    /**
     */
    async nurseControllerListOrientations(requestParameters, initOverrides) {
        const response = await this.nurseControllerListOrientationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerListShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerListShifts().');
        }
        const queryParameters = {};
        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'].toISOString();
        }
        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'].toISOString();
        }
        if (requestParameters['requestStatus'] != null) {
            queryParameters['requestStatus'] = requestParameters['requestStatus'];
        }
        if (requestParameters['requestedBy'] != null) {
            queryParameters['requestedBy'] = requestParameters['requestedBy'];
        }
        if (requestParameters['hasTimeLogged'] != null) {
            queryParameters['hasTimeLogged'] = requestParameters['hasTimeLogged'];
        }
        if (requestParameters['shiftStatus'] != null) {
            queryParameters['shiftStatus'] = requestParameters['shiftStatus'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/shift`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfRequestedShiftDtoFromJSON)(jsonValue));
    }
    /**
     */
    async nurseControllerListShifts(requestParameters, initOverrides) {
        const response = await this.nurseControllerListShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerResetConfidentialityAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerResetConfidentialityAgreement().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/confidentiality-agreement`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nurseControllerResetConfidentialityAgreement(requestParameters, initOverrides) {
        await this.nurseControllerResetConfidentialityAgreementRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nurseControllerResetContractRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerResetContract().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/contract`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nurseControllerResetContract(requestParameters, initOverrides) {
        await this.nurseControllerResetContractRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nurseControllerReverifyLicenseRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerReverifyLicense().');
        }
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError('licenseId', 'Required parameter "licenseId" was null or undefined when calling nurseControllerReverifyLicense().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/license/{licenseId}/reverify`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"licenseId"}}`, encodeURIComponent(String(requestParameters['licenseId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nurseControllerReverifyLicense(requestParameters, initOverrides) {
        await this.nurseControllerReverifyLicenseRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nurseControllerSignConfidentialityAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerSignConfidentialityAgreement().');
        }
        if (requestParameters['signConfidentialityAgreementDto'] == null) {
            throw new runtime.RequiredError('signConfidentialityAgreementDto', 'Required parameter "signConfidentialityAgreementDto" was null or undefined when calling nurseControllerSignConfidentialityAgreement().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/confidentiality-agreement`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SignConfidentialityAgreementDtoToJSON)(requestParameters['signConfidentialityAgreementDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ConfidentialityAgreementDtoFromJSON)(jsonValue));
    }
    /**
     */
    async nurseControllerSignConfidentialityAgreement(requestParameters, initOverrides) {
        const response = await this.nurseControllerSignConfidentialityAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerSignContractRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerSignContract().');
        }
        if (requestParameters['signEmploymentContractDto'] == null) {
            throw new runtime.RequiredError('signEmploymentContractDto', 'Required parameter "signEmploymentContractDto" was null or undefined when calling nurseControllerSignContract().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/contract`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SignEmploymentContractDtoToJSON)(requestParameters['signEmploymentContractDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.EmploymentContractDtoFromJSON)(jsonValue));
    }
    /**
     */
    async nurseControllerSignContract(requestParameters, initOverrides) {
        const response = await this.nurseControllerSignContractRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerUpdateNurseEmrsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerUpdateNurseEmrs().');
        }
        if (requestParameters['electronicMedicalRecordSystemsUpdateDto'] == null) {
            throw new runtime.RequiredError('electronicMedicalRecordSystemsUpdateDto', 'Required parameter "electronicMedicalRecordSystemsUpdateDto" was null or undefined when calling nurseControllerUpdateNurseEmrs().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/emr`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ElectronicMedicalRecordSystemsUpdateDtoToJSON)(requestParameters['electronicMedicalRecordSystemsUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ElectronicMedicalRecordSystemDtoFromJSON));
    }
    /**
     */
    async nurseControllerUpdateNurseEmrs(requestParameters, initOverrides) {
        const response = await this.nurseControllerUpdateNurseEmrsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseControllerUpsertVerifiedLicensesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerUpsertVerifiedLicenses().');
        }
        if (requestParameters['createVerifiedNurseLicensesDto'] == null) {
            throw new runtime.RequiredError('createVerifiedNurseLicensesDto', 'Required parameter "createVerifiedNurseLicensesDto" was null or undefined when calling nurseControllerUpsertVerifiedLicenses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/license`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CreateVerifiedNurseLicensesDtoToJSON)(requestParameters['createVerifiedNurseLicensesDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseLicenseDtoFromJSON));
    }
    /**
     */
    async nurseControllerUpsertVerifiedLicenses(requestParameters, initOverrides) {
        const response = await this.nurseControllerUpsertVerifiedLicensesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseLicenseCompactControllerCreateNurseLicenseCompactRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseLicenseCompactDto'] == null) {
            throw new runtime.RequiredError('nurseLicenseCompactDto', 'Required parameter "nurseLicenseCompactDto" was null or undefined when calling nurseLicenseCompactControllerCreateNurseLicenseCompact().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-license-compact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NurseLicenseCompactDtoToJSON)(requestParameters['nurseLicenseCompactDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nurseLicenseCompactControllerCreateNurseLicenseCompact(requestParameters, initOverrides) {
        await this.nurseLicenseCompactControllerCreateNurseLicenseCompactRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nurseLicenseCompactControllerGetNurseLicenseCompactRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling nurseLicenseCompactControllerGetNurseLicenseCompact().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-license-compact/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.NurseLicenseCompactDetailsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async nurseLicenseCompactControllerGetNurseLicenseCompact(requestParameters, initOverrides) {
        const response = await this.nurseLicenseCompactControllerGetNurseLicenseCompactRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseLicenseCompactControllerListNurseLicenseCompactsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-license-compact`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseLicenseCompactDtoFromJSON));
    }
    /**
     */
    async nurseLicenseCompactControllerListNurseLicenseCompacts(requestParameters = {}, initOverrides) {
        const response = await this.nurseLicenseCompactControllerListNurseLicenseCompactsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseLicenseCompactControllerUpdateNurseLicenseCompactRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling nurseLicenseCompactControllerUpdateNurseLicenseCompact().');
        }
        if (requestParameters['nurseLicenseCompactUpdateDto'] == null) {
            throw new runtime.RequiredError('nurseLicenseCompactUpdateDto', 'Required parameter "nurseLicenseCompactUpdateDto" was null or undefined when calling nurseLicenseCompactControllerUpdateNurseLicenseCompact().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-license-compact/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NurseLicenseCompactUpdateDtoToJSON)(requestParameters['nurseLicenseCompactUpdateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nurseLicenseCompactControllerUpdateNurseLicenseCompact(requestParameters, initOverrides) {
        await this.nurseLicenseCompactControllerUpdateNurseLicenseCompactRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nurseStatePracticeAuthorizationControllerDeleteNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling nurseStatePracticeAuthorizationControllerDeleteNurseStatePracticeAuthorizations().');
        }
        const queryParameters = {};
        if (requestParameters['states'] != null) {
            queryParameters['states'] = requestParameters['states'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-state-practice-authorization/{nurseProfileId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nurseStatePracticeAuthorizationControllerDeleteNurseStatePracticeAuthorizations(requestParameters, initOverrides) {
        await this.nurseStatePracticeAuthorizationControllerDeleteNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nurseStatePracticeAuthorizationControllerGetNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling nurseStatePracticeAuthorizationControllerGetNurseStatePracticeAuthorizations().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-state-practice-authorization/{nurseProfileId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.AuthorizedStateDtoFromJSON));
    }
    /**
     */
    async nurseStatePracticeAuthorizationControllerGetNurseStatePracticeAuthorizations(requestParameters, initOverrides) {
        const response = await this.nurseStatePracticeAuthorizationControllerGetNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async nurseStatePracticeAuthorizationControllerUpdateNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling nurseStatePracticeAuthorizationControllerUpdateNurseStatePracticeAuthorizations().');
        }
        if (requestParameters['updateNurseStatePracticeAuthorizationsDto'] == null) {
            throw new runtime.RequiredError('updateNurseStatePracticeAuthorizationsDto', 'Required parameter "updateNurseStatePracticeAuthorizationsDto" was null or undefined when calling nurseStatePracticeAuthorizationControllerUpdateNurseStatePracticeAuthorizations().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-state-practice-authorization/{nurseProfileId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.UpdateNurseStatePracticeAuthorizationsDtoToJSON)(requestParameters['updateNurseStatePracticeAuthorizationsDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nurseStatePracticeAuthorizationControllerUpdateNurseStatePracticeAuthorizations(requestParameters, initOverrides) {
        await this.nurseStatePracticeAuthorizationControllerUpdateNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nursysControllerCreateNursysTransactionRaw(requestParameters, initOverrides) {
        if (requestParameters['createNursysTransactionDto'] == null) {
            throw new runtime.RequiredError('createNursysTransactionDto', 'Required parameter "createNursysTransactionDto" was null or undefined when calling nursysControllerCreateNursysTransaction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nursys/transaction`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CreateNursysTransactionDtoToJSON)(requestParameters['createNursysTransactionDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nursysControllerCreateNursysTransaction(requestParameters, initOverrides) {
        await this.nursysControllerCreateNursysTransactionRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nursysControllerGetPendingNursysTransactionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nursys/transaction/pending`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NursysTransactionDtoFromJSON));
    }
    /**
     */
    async nursysControllerGetPendingNursysTransactions(initOverrides) {
        const response = await this.nursysControllerGetPendingNursysTransactionsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async nursysControllerUpdateLicenseNursysTransactionRaw(requestParameters, initOverrides) {
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError('licenseId', 'Required parameter "licenseId" was null or undefined when calling nursysControllerUpdateLicenseNursysTransaction().');
        }
        if (requestParameters['transactionId'] == null) {
            throw new runtime.RequiredError('transactionId', 'Required parameter "transactionId" was null or undefined when calling nursysControllerUpdateLicenseNursysTransaction().');
        }
        if (requestParameters['licenseNursysTransactionUpdateStatusDto'] == null) {
            throw new runtime.RequiredError('licenseNursysTransactionUpdateStatusDto', 'Required parameter "licenseNursysTransactionUpdateStatusDto" was null or undefined when calling nursysControllerUpdateLicenseNursysTransaction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nursys/transaction/{transactionId}/license/{licenseId}`.replace(`{${"licenseId"}}`, encodeURIComponent(String(requestParameters['licenseId']))).replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters['transactionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.LicenseNursysTransactionUpdateStatusDtoToJSON)(requestParameters['licenseNursysTransactionUpdateStatusDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nursysControllerUpdateLicenseNursysTransaction(requestParameters, initOverrides) {
        await this.nursysControllerUpdateLicenseNursysTransactionRaw(requestParameters, initOverrides);
    }
    /**
     */
    async nursysControllerUpdateNursysTransactionRaw(requestParameters, initOverrides) {
        if (requestParameters['transactionId'] == null) {
            throw new runtime.RequiredError('transactionId', 'Required parameter "transactionId" was null or undefined when calling nursysControllerUpdateNursysTransaction().');
        }
        if (requestParameters['nursysTransactionUpdateDto'] == null) {
            throw new runtime.RequiredError('nursysTransactionUpdateDto', 'Required parameter "nursysTransactionUpdateDto" was null or undefined when calling nursysControllerUpdateNursysTransaction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nursys/transaction/{transactionId}`.replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters['transactionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NursysTransactionUpdateDtoToJSON)(requestParameters['nursysTransactionUpdateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async nursysControllerUpdateNursysTransaction(requestParameters, initOverrides) {
        await this.nursysControllerUpdateNursysTransactionRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerAcceptFacilityRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerAcceptFacilityRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerAcceptFacilityRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/nurse/{profileId}/accept`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerAcceptFacilityRequest(requestParameters, initOverrides) {
        await this.orientationControllerAcceptFacilityRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerApproveNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerApproveNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerApproveNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/nurse/{profileId}/approve`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerApproveNurseRequest(requestParameters, initOverrides) {
        await this.orientationControllerApproveNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerCancelNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerCancelNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerCancelNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/nurse/{profileId}/request`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerCancelNurseRequest(requestParameters, initOverrides) {
        await this.orientationControllerCancelNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerCancelOrientationRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerCancelOrientation().');
        }
        if (requestParameters['orientationCancellationDto'] == null) {
            throw new runtime.RequiredError('orientationCancellationDto', 'Required parameter "orientationCancellationDto" was null or undefined when calling orientationControllerCancelOrientation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationCancellationDtoToJSON)(requestParameters['orientationCancellationDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerCancelOrientation(requestParameters, initOverrides) {
        await this.orientationControllerCancelOrientationRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerCancelOrientationAssignmentRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerCancelOrientationAssignment().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerCancelOrientationAssignment().');
        }
        if (requestParameters['nurseOrientationCancellationCreateDto'] == null) {
            throw new runtime.RequiredError('nurseOrientationCancellationCreateDto', 'Required parameter "nurseOrientationCancellationCreateDto" was null or undefined when calling orientationControllerCancelOrientationAssignment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/nurse/{profileId}/assignment`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NurseOrientationCancellationCreateDtoToJSON)(requestParameters['nurseOrientationCancellationCreateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerCancelOrientationAssignment(requestParameters, initOverrides) {
        await this.orientationControllerCancelOrientationAssignmentRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerCancelOrientationRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerCancelOrientationRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerCancelOrientationRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/nurse/{profileId}`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerCancelOrientationRequest(requestParameters, initOverrides) {
        await this.orientationControllerCancelOrientationRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerCreateOrientationRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationCreateDto'] == null) {
            throw new runtime.RequiredError('orientationCreateDto', 'Required parameter "orientationCreateDto" was null or undefined when calling orientationControllerCreateOrientation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationCreateDtoToJSON)(requestParameters['orientationCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrientationDtoFromJSON)(jsonValue));
    }
    /**
     */
    async orientationControllerCreateOrientation(requestParameters, initOverrides) {
        const response = await this.orientationControllerCreateOrientationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async orientationControllerDeclineFacilityRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerDeclineFacilityRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerDeclineFacilityRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/nurse/{profileId}/decline`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerDeclineFacilityRequest(requestParameters, initOverrides) {
        await this.orientationControllerDeclineFacilityRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerDeclineNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerDeclineNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerDeclineNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/nurse/{profileId}/reject`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerDeclineNurseRequest(requestParameters, initOverrides) {
        await this.orientationControllerDeclineNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerDeleteOrientationDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerDeleteOrientationDocument().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerDeleteOrientationDocument().');
        }
        if (requestParameters['fileName'] == null) {
            throw new runtime.RequiredError('fileName', 'Required parameter "fileName" was null or undefined when calling orientationControllerDeleteOrientationDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/document/{profileId}/{fileName}`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters['fileName']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerDeleteOrientationDocument(requestParameters, initOverrides) {
        await this.orientationControllerDeleteOrientationDocumentRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerDismissDeclinedNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerDismissDeclinedNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerDismissDeclinedNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/nurse/{profileId}/dismiss`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerDismissDeclinedNurseRequest(requestParameters, initOverrides) {
        await this.orientationControllerDismissDeclinedNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerGetOrientationRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerGetOrientation().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrientationDetailsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async orientationControllerGetOrientation(requestParameters, initOverrides) {
        const response = await this.orientationControllerGetOrientationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async orientationControllerGetOrientationClaimedSeatsRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerGetOrientationClaimedSeats().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/claimed`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.OrientationClaimDtoFromJSON));
    }
    /**
     */
    async orientationControllerGetOrientationClaimedSeats(requestParameters, initOverrides) {
        const response = await this.orientationControllerGetOrientationClaimedSeatsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async orientationControllerGetOrientationMinutesWorkedRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerGetOrientationMinutesWorked().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerGetOrientationMinutesWorked().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/time-worked/{profileId}`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.OrientationSessionHoursDtoFromJSON));
    }
    /**
     */
    async orientationControllerGetOrientationMinutesWorked(requestParameters, initOverrides) {
        const response = await this.orientationControllerGetOrientationMinutesWorkedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async orientationControllerRequestNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerRequestNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerRequestNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/nurse/{profileId}/request`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerRequestNurse(requestParameters, initOverrides) {
        await this.orientationControllerRequestNurseRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerRequestOrientationRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerRequestOrientation().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerRequestOrientation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/nurse/{profileId}`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerRequestOrientation(requestParameters, initOverrides) {
        await this.orientationControllerRequestOrientationRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerSubmitTimeWorkedRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationTimeWorkedDto'] == null) {
            throw new runtime.RequiredError('orientationTimeWorkedDto', 'Required parameter "orientationTimeWorkedDto" was null or undefined when calling orientationControllerSubmitTimeWorked().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/time-worked`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationTimeWorkedDtoToJSON)(requestParameters['orientationTimeWorkedDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerSubmitTimeWorked(requestParameters, initOverrides) {
        await this.orientationControllerSubmitTimeWorkedRaw(requestParameters, initOverrides);
    }
    /**
     */
    async orientationControllerUpdateOrientationRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerUpdateOrientation().');
        }
        if (requestParameters['orientationUpdateDto'] == null) {
            throw new runtime.RequiredError('orientationUpdateDto', 'Required parameter "orientationUpdateDto" was null or undefined when calling orientationControllerUpdateOrientation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation/{orientationId}`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationUpdateDtoToJSON)(requestParameters['orientationUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrientationDtoFromJSON)(jsonValue));
    }
    /**
     */
    async orientationControllerUpdateOrientation(requestParameters, initOverrides) {
        const response = await this.orientationControllerUpdateOrientationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async orientationControllerUploadOrientationDocumentsRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationId'] == null) {
            throw new runtime.RequiredError('orientationId', 'Required parameter "orientationId" was null or undefined when calling orientationControllerUploadOrientationDocuments().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationControllerUploadOrientationDocuments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['documents'] != null) {
            requestParameters['documents'].forEach((element) => {
                formParams.append('documents', element);
            });
        }
        const response = await this.request({
            path: `/orientation/{orientationId}/document/{profileId}`.replace(`{${"orientationId"}}`, encodeURIComponent(String(requestParameters['orientationId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async orientationControllerUploadOrientationDocuments(requestParameters, initOverrides) {
        await this.orientationControllerUploadOrientationDocumentsRaw(requestParameters, initOverrides);
    }
    /**
     * Get all unnotified orientation matches
     */
    async orientationMatchControllerFindAllOrientationMatchesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-matches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ProfileOrientationMatchesDtoFromJSON));
    }
    /**
     * Get all unnotified orientation matches
     */
    async orientationMatchControllerFindAllOrientationMatches(initOverrides) {
        const response = await this.orientationMatchControllerFindAllOrientationMatchesRaw(initOverrides);
        return await response.value();
    }
    /**
     * Notify nurse of orientation matches
     */
    async orientationMatchControllerNotifyProfileOfOrientationMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationMatchControllerNotifyProfileOfOrientationMatches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-matches/notify/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Notify nurse of orientation matches
     */
    async orientationMatchControllerNotifyProfileOfOrientationMatches(requestParameters, initOverrides) {
        await this.orientationMatchControllerNotifyProfileOfOrientationMatchesRaw(requestParameters, initOverrides);
    }
    /**
     * Record orientation matches
     */
    async orientationMatchControllerRecordOrientationMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['recordOrientationMatchesDto'] == null) {
            throw new runtime.RequiredError('recordOrientationMatchesDto', 'Required parameter "recordOrientationMatchesDto" was null or undefined when calling orientationMatchControllerRecordOrientationMatches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-matches`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RecordOrientationMatchesDtoToJSON)(requestParameters['recordOrientationMatchesDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Record orientation matches
     */
    async orientationMatchControllerRecordOrientationMatches(requestParameters, initOverrides) {
        await this.orientationMatchControllerRecordOrientationMatchesRaw(requestParameters, initOverrides);
    }
    /**
     */
    async payPeriodControllerCreatePayPeriodRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling payPeriodControllerCreatePayPeriod().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pay-periods/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async payPeriodControllerCreatePayPeriod(requestParameters, initOverrides) {
        await this.payPeriodControllerCreatePayPeriodRaw(requestParameters, initOverrides);
    }
    /**
     */
    async payPeriodControllerGetAllPayPeriodsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pay-periods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PayPeriodAbbrDtoFromJSON));
    }
    /**
     */
    async payPeriodControllerGetAllPayPeriods(initOverrides) {
        const response = await this.payPeriodControllerGetAllPayPeriodsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerApproveEmployeeCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['employeeCheckId'] == null) {
            throw new runtime.RequiredError('employeeCheckId', 'Required parameter "employeeCheckId" was null or undefined when calling payrollControllerApproveEmployeeCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/employee-checks/{employeeCheckId}/approve`.replace(`{${"employeeCheckId"}}`, encodeURIComponent(String(requestParameters['employeeCheckId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollEmployeeCheckDtoFromJSON)(jsonValue));
    }
    /**
     */
    async payrollControllerApproveEmployeeCheck(requestParameters, initOverrides) {
        const response = await this.payrollControllerApproveEmployeeCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerGetCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError('checkId', 'Required parameter "checkId" was null or undefined when calling payrollControllerGetCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/checks/{checkId}`.replace(`{${"checkId"}}`, encodeURIComponent(String(requestParameters['checkId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollEmployeeCheckDtoFromJSON)(jsonValue));
    }
    /**
     */
    async payrollControllerGetCheck(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerGetI9LinkRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerGetI9Link().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/i9-link`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollLinkDtoFromJSON)(jsonValue));
    }
    /**
     */
    async payrollControllerGetI9Link(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetI9LinkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerGetLinkRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerGetLink().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/{profileId}/link`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollLinkDtoFromJSON)(jsonValue));
    }
    /**
     */
    async payrollControllerGetLink(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerGetPaychecksRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['isApproved'] != null) {
            queryParameters['isApproved'] = requestParameters['isApproved'];
        }
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['payPeriodStart'] != null) {
            queryParameters['payPeriodStart'] = requestParameters['payPeriodStart'].toISOString();
        }
        if (requestParameters['payPeriodEnd'] != null) {
            queryParameters['payPeriodEnd'] = requestParameters['payPeriodEnd'].toISOString();
        }
        if (requestParameters['forceSync'] != null) {
            queryParameters['forceSync'] = requestParameters['forceSync'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/employee-checks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PayrollEmployeeCheckDtoFromJSON));
    }
    /**
     */
    async payrollControllerGetPaychecks(requestParameters = {}, initOverrides) {
        const response = await this.payrollControllerGetPaychecksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerGetPaystubLinkRaw(requestParameters, initOverrides) {
        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError('checkId', 'Required parameter "checkId" was null or undefined when calling payrollControllerGetPaystubLink().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/checks/{checkId}/paystub-link`.replace(`{${"checkId"}}`, encodeURIComponent(String(requestParameters['checkId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollLinkDtoFromJSON)(jsonValue));
    }
    /**
     */
    async payrollControllerGetPaystubLink(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetPaystubLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerGetProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerGetProfile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/{profileId}/profile`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async payrollControllerGetProfile(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerGetW4LinkRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerGetW4Link().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        if (requestParameters['jurisdiction'] != null) {
            queryParameters['jurisdiction'] = requestParameters['jurisdiction'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/w4-link`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollLinkDtoFromJSON)(jsonValue));
    }
    /**
     */
    async payrollControllerGetW4Link(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetW4LinkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerHistoryRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerHistory().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/{profileId}/history`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PayrollEmployeeCheckDtoFromJSON));
    }
    /**
     */
    async payrollControllerHistory(requestParameters, initOverrides) {
        const response = await this.payrollControllerHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerListPayrollShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['after'] == null) {
            throw new runtime.RequiredError('after', 'Required parameter "after" was null or undefined when calling payrollControllerListPayrollShifts().');
        }
        if (requestParameters['before'] == null) {
            throw new runtime.RequiredError('before', 'Required parameter "before" was null or undefined when calling payrollControllerListPayrollShifts().');
        }
        const queryParameters = {};
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'].toISOString();
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'].toISOString();
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/shifts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PayrollShiftListItemDtoFromJSON));
    }
    /**
     */
    async payrollControllerListPayrollShifts(requestParameters, initOverrides) {
        const response = await this.payrollControllerListPayrollShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerResetOnboardingRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerResetOnboarding().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/{profileId}/reset`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async payrollControllerResetOnboarding(requestParameters, initOverrides) {
        await this.payrollControllerResetOnboardingRaw(requestParameters, initOverrides);
    }
    /**
     */
    async payrollControllerSetPayPeriodZealCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['payPeriodId'] == null) {
            throw new runtime.RequiredError('payPeriodId', 'Required parameter "payPeriodId" was null or undefined when calling payrollControllerSetPayPeriodZealCheck().');
        }
        if (requestParameters['setZealCheckDto'] == null) {
            throw new runtime.RequiredError('setZealCheckDto', 'Required parameter "setZealCheckDto" was null or undefined when calling payrollControllerSetPayPeriodZealCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/pay-periods/{payPeriodId}/zeal-check`.replace(`{${"payPeriodId"}}`, encodeURIComponent(String(requestParameters['payPeriodId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SetZealCheckDtoToJSON)(requestParameters['setZealCheckDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollEmployeeCheckDtoFromJSON)(jsonValue));
    }
    /**
     */
    async payrollControllerSetPayPeriodZealCheck(requestParameters, initOverrides) {
        const response = await this.payrollControllerSetPayPeriodZealCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerUnapproveEmployeeCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['employeeCheckId'] == null) {
            throw new runtime.RequiredError('employeeCheckId', 'Required parameter "employeeCheckId" was null or undefined when calling payrollControllerUnapproveEmployeeCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/employee-checks/{employeeCheckId}/approve`.replace(`{${"employeeCheckId"}}`, encodeURIComponent(String(requestParameters['employeeCheckId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollEmployeeCheckDtoFromJSON)(jsonValue));
    }
    /**
     */
    async payrollControllerUnapproveEmployeeCheck(requestParameters, initOverrides) {
        const response = await this.payrollControllerUnapproveEmployeeCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollOnboardingControllerHandlePayrollOnboardingWebhookRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/payroll/webhook/onboarding`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async payrollOnboardingControllerHandlePayrollOnboardingWebhook(initOverrides) {
        await this.payrollOnboardingControllerHandlePayrollOnboardingWebhookRaw(initOverrides);
    }
    /**
     */
    async pingControllerGetPingRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/ping`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async pingControllerGetPing(initOverrides) {
        await this.pingControllerGetPingRaw(initOverrides);
    }
    /**
     */
    async platformAdminControllerGetPlatformAdminsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/platform-admin`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PlatformAdminDtoFromJSON));
    }
    /**
     */
    async platformAdminControllerGetPlatformAdmins(initOverrides) {
        const response = await this.platformAdminControllerGetPlatformAdminsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerCreateProfileAddressRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerCreateProfileAddress().');
        }
        if (requestParameters['addressCreateDto'] == null) {
            throw new runtime.RequiredError('addressCreateDto', 'Required parameter "addressCreateDto" was null or undefined when calling profileControllerCreateProfileAddress().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/address`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.AddressCreateDtoToJSON)(requestParameters['addressCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.AddressDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerCreateProfileAddress(requestParameters, initOverrides) {
        const response = await this.profileControllerCreateProfileAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerCreateProfilePhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerCreateProfilePhoneNumber().');
        }
        if (requestParameters['phoneNumberCreateDto'] == null) {
            throw new runtime.RequiredError('phoneNumberCreateDto', 'Required parameter "phoneNumberCreateDto" was null or undefined when calling profileControllerCreateProfilePhoneNumber().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/phoneNumber`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.PhoneNumberCreateDtoToJSON)(requestParameters['phoneNumberCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PhoneNumberDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerCreateProfilePhoneNumber(requestParameters, initOverrides) {
        const response = await this.profileControllerCreateProfilePhoneNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerDeleteProfileAddressRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerDeleteProfileAddress().');
        }
        if (requestParameters['addressId'] == null) {
            throw new runtime.RequiredError('addressId', 'Required parameter "addressId" was null or undefined when calling profileControllerDeleteProfileAddress().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/address/{addressId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"addressId"}}`, encodeURIComponent(String(requestParameters['addressId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async profileControllerDeleteProfileAddress(requestParameters, initOverrides) {
        await this.profileControllerDeleteProfileAddressRaw(requestParameters, initOverrides);
    }
    /**
     */
    async profileControllerDeleteProfilePhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerDeleteProfilePhoneNumber().');
        }
        if (requestParameters['phoneNumberId'] == null) {
            throw new runtime.RequiredError('phoneNumberId', 'Required parameter "phoneNumberId" was null or undefined when calling profileControllerDeleteProfilePhoneNumber().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/phoneNumber/{phoneNumberId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"phoneNumberId"}}`, encodeURIComponent(String(requestParameters['phoneNumberId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async profileControllerDeleteProfilePhoneNumber(requestParameters, initOverrides) {
        await this.profileControllerDeleteProfilePhoneNumberRaw(requestParameters, initOverrides);
    }
    /**
     */
    async profileControllerGetAvatarRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetAvatar().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/avatar`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.AvatarDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetAvatar(requestParameters, initOverrides) {
        const response = await this.profileControllerGetAvatarRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetBasicProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetBasicProfile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/basic`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.BasicProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetBasicProfile(requestParameters, initOverrides) {
        const response = await this.profileControllerGetBasicProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetCurrentUserAvatarRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/me/avatar`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.AvatarDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetCurrentUserAvatar(initOverrides) {
        const response = await this.profileControllerGetCurrentUserAvatarRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetCurrentUserProfileRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetCurrentUserProfile(initOverrides) {
        const response = await this.profileControllerGetCurrentUserProfileRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetCurrentUserRolesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/me/roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RolesDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetCurrentUserRoles(initOverrides) {
        const response = await this.profileControllerGetCurrentUserRolesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetMemberFacilitiesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetMemberFacilities().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/facilities`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityDtoFromJSON));
    }
    /**
     */
    async profileControllerGetMemberFacilities(requestParameters, initOverrides) {
        const response = await this.profileControllerGetMemberFacilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetProfile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetProfile(requestParameters, initOverrides) {
        const response = await this.profileControllerGetProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetProfileAddressesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetProfileAddresses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/address`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.AddressDtoFromJSON));
    }
    /**
     */
    async profileControllerGetProfileAddresses(requestParameters, initOverrides) {
        const response = await this.profileControllerGetProfileAddressesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetProfilePhoneNumbersRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetProfilePhoneNumbers().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/phoneNumber`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PhoneNumberDtoFromJSON));
    }
    /**
     */
    async profileControllerGetProfilePhoneNumbers(requestParameters, initOverrides) {
        const response = await this.profileControllerGetProfilePhoneNumbersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetProfileShiftPreferencesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetProfileShiftPreferences().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/preference/shifts`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftPreferencesDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetProfileShiftPreferences(requestParameters, initOverrides) {
        const response = await this.profileControllerGetProfileShiftPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetProfileVerifiedFacilitiesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetProfileVerifiedFacilities().');
        }
        const queryParameters = {};
        if (requestParameters['includeAllFacilities'] != null) {
            queryParameters['includeAllFacilities'] = requestParameters['includeAllFacilities'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/verified-facilities`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityVerificationDtoFromJSON));
    }
    /**
     */
    async profileControllerGetProfileVerifiedFacilities(requestParameters, initOverrides) {
        const response = await this.profileControllerGetProfileVerifiedFacilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetPublicProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetPublicProfile().');
        }
        const queryParameters = {};
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/public`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PublicProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetPublicProfile(requestParameters, initOverrides) {
        const response = await this.profileControllerGetPublicProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetResumeRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetResume().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/resume`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetResume(requestParameters, initOverrides) {
        const response = await this.profileControllerGetResumeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetUserPermissionsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetUserPermissions().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/permissions`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PermissionsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetUserPermissions(requestParameters, initOverrides) {
        const response = await this.profileControllerGetUserPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerGetUserRolesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetUserRoles().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/roles`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RolesDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerGetUserRoles(requestParameters, initOverrides) {
        const response = await this.profileControllerGetUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerListProfilesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['dhsBackgroundCheckStatus'] != null) {
            queryParameters['dhsBackgroundCheckStatus'] = requestParameters['dhsBackgroundCheckStatus'];
        }
        if (requestParameters['certificationVerificationStatus'] != null) {
            queryParameters['certificationVerificationStatus'] = requestParameters['certificationVerificationStatus'];
        }
        if (requestParameters['hasExpiredCertification'] != null) {
            queryParameters['hasExpiredCertification'] = requestParameters['hasExpiredCertification'];
        }
        if (requestParameters['hasExpiredLicense'] != null) {
            queryParameters['hasExpiredLicense'] = requestParameters['hasExpiredLicense'];
        }
        if (requestParameters['hasExhaustedAssessment'] != null) {
            queryParameters['hasExhaustedAssessment'] = requestParameters['hasExhaustedAssessment'];
        }
        if (requestParameters['hasCompleteProfile'] != null) {
            queryParameters['hasCompleteProfile'] = requestParameters['hasCompleteProfile'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ListProfileDtoFromJSON));
    }
    /**
     */
    async profileControllerListProfiles(requestParameters = {}, initOverrides) {
        const response = await this.profileControllerListProfilesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerUpdateProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUpdateProfile().');
        }
        if (requestParameters['profileUpdateDto'] == null) {
            throw new runtime.RequiredError('profileUpdateDto', 'Required parameter "profileUpdateDto" was null or undefined when calling profileControllerUpdateProfile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ProfileUpdateDtoToJSON)(requestParameters['profileUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerUpdateProfile(requestParameters, initOverrides) {
        const response = await this.profileControllerUpdateProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerUpdateProfileAddressRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUpdateProfileAddress().');
        }
        if (requestParameters['addressId'] == null) {
            throw new runtime.RequiredError('addressId', 'Required parameter "addressId" was null or undefined when calling profileControllerUpdateProfileAddress().');
        }
        if (requestParameters['addressUpdateDto'] == null) {
            throw new runtime.RequiredError('addressUpdateDto', 'Required parameter "addressUpdateDto" was null or undefined when calling profileControllerUpdateProfileAddress().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/address/{addressId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"addressId"}}`, encodeURIComponent(String(requestParameters['addressId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.AddressUpdateDtoToJSON)(requestParameters['addressUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.AddressDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerUpdateProfileAddress(requestParameters, initOverrides) {
        const response = await this.profileControllerUpdateProfileAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerUpdateProfilePhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUpdateProfilePhoneNumber().');
        }
        if (requestParameters['phoneNumberId'] == null) {
            throw new runtime.RequiredError('phoneNumberId', 'Required parameter "phoneNumberId" was null or undefined when calling profileControllerUpdateProfilePhoneNumber().');
        }
        if (requestParameters['phoneNumberUpdateDto'] == null) {
            throw new runtime.RequiredError('phoneNumberUpdateDto', 'Required parameter "phoneNumberUpdateDto" was null or undefined when calling profileControllerUpdateProfilePhoneNumber().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/phoneNumber/{phoneNumberId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"phoneNumberId"}}`, encodeURIComponent(String(requestParameters['phoneNumberId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.PhoneNumberUpdateDtoToJSON)(requestParameters['phoneNumberUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PhoneNumberDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerUpdateProfilePhoneNumber(requestParameters, initOverrides) {
        const response = await this.profileControllerUpdateProfilePhoneNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerUpdateProfileProfessionalSummaryRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUpdateProfileProfessionalSummary().');
        }
        if (requestParameters['professionalSummaryDto'] == null) {
            throw new runtime.RequiredError('professionalSummaryDto', 'Required parameter "professionalSummaryDto" was null or undefined when calling profileControllerUpdateProfileProfessionalSummary().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/professional-summary`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ProfessionalSummaryDtoToJSON)(requestParameters['professionalSummaryDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async profileControllerUpdateProfileProfessionalSummary(requestParameters, initOverrides) {
        await this.profileControllerUpdateProfileProfessionalSummaryRaw(requestParameters, initOverrides);
    }
    /**
     */
    async profileControllerUpdateProfileShiftPreferencesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUpdateProfileShiftPreferences().');
        }
        if (requestParameters['shiftPreferencesDto'] == null) {
            throw new runtime.RequiredError('shiftPreferencesDto', 'Required parameter "shiftPreferencesDto" was null or undefined when calling profileControllerUpdateProfileShiftPreferences().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/preference/shifts`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftPreferencesDtoToJSON)(requestParameters['shiftPreferencesDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftPreferencesDtoFromJSON)(jsonValue));
    }
    /**
     */
    async profileControllerUpdateProfileShiftPreferences(requestParameters, initOverrides) {
        const response = await this.profileControllerUpdateProfileShiftPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async profileControllerUploadProfilePhotoRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUploadProfilePhoto().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['profilePhoto'] != null) {
            formParams.append('profilePhoto', requestParameters['profilePhoto']);
        }
        const response = await this.request({
            path: `/profile/{profileId}/photo`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async profileControllerUploadProfilePhoto(requestParameters, initOverrides) {
        await this.profileControllerUploadProfilePhotoRaw(requestParameters, initOverrides);
    }
    /**
     */
    async profileControllerUploadResumeRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUploadResume().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['resume'] != null) {
            formParams.append('resume', requestParameters['resume']);
        }
        const response = await this.request({
            path: `/profile/{profileId}/resume`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async profileControllerUploadResume(requestParameters, initOverrides) {
        await this.profileControllerUploadResumeRaw(requestParameters, initOverrides);
    }
    /**
     */
    async rateCalculatorControllerGetEstimatedRateRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }
        if (requestParameters['experience'] != null) {
            queryParameters['experience'] = requestParameters['experience'];
        }
        if (requestParameters['specialty'] != null) {
            queryParameters['specialty'] = requestParameters['specialty'];
        }
        if (requestParameters['sector'] != null) {
            queryParameters['sector'] = requestParameters['sector'];
        }
        if (requestParameters['adjustments'] != null) {
            queryParameters['adjustments'] = requestParameters['adjustments'];
        }
        if (requestParameters['employerTaxPercentage'] != null) {
            queryParameters['employerTaxPercentage'] = requestParameters['employerTaxPercentage'];
        }
        if (requestParameters['platformFeePercentage'] != null) {
            queryParameters['platformFeePercentage'] = requestParameters['platformFeePercentage'];
        }
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rate-calculator`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RateEstimateDtoFromJSON)(jsonValue));
    }
    /**
     */
    async rateCalculatorControllerGetEstimatedRate(requestParameters = {}, initOverrides) {
        const response = await this.rateCalculatorControllerGetEstimatedRateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async rateCalculatorControllerGetOptionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rate-calculator/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RateCalculatorOptionsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async rateCalculatorControllerGetOptions(initOverrides) {
        const response = await this.rateCalculatorControllerGetOptionsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Create a new regulatory assessment
     */
    async regulatoryAssessmentsControllerCreateRegulatoryAssessmentRaw(requestParameters, initOverrides) {
        if (requestParameters['regulatoryAssessmentAdminDto'] == null) {
            throw new runtime.RequiredError('regulatoryAssessmentAdminDto', 'Required parameter "regulatoryAssessmentAdminDto" was null or undefined when calling regulatoryAssessmentsControllerCreateRegulatoryAssessment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/regulatory-assessments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegulatoryAssessmentAdminDtoToJSON)(requestParameters['regulatoryAssessmentAdminDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentAdminDtoFromJSON)(jsonValue));
    }
    /**
     * Create a new regulatory assessment
     */
    async regulatoryAssessmentsControllerCreateRegulatoryAssessment(requestParameters, initOverrides) {
        const response = await this.regulatoryAssessmentsControllerCreateRegulatoryAssessmentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a specific regulatory assessment
     */
    async regulatoryAssessmentsControllerGetRegulatoryAssessmentRaw(requestParameters, initOverrides) {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling regulatoryAssessmentsControllerGetRegulatoryAssessment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/regulatory-assessments/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentAdminDtoFromJSON)(jsonValue));
    }
    /**
     * Get a specific regulatory assessment
     */
    async regulatoryAssessmentsControllerGetRegulatoryAssessment(requestParameters, initOverrides) {
        const response = await this.regulatoryAssessmentsControllerGetRegulatoryAssessmentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async regulatoryAssessmentsControllerGetRegulatoryAssessmentsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/regulatory-assessments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentAdminListDtoFromJSON)(jsonValue));
    }
    /**
     */
    async regulatoryAssessmentsControllerGetRegulatoryAssessments(requestParameters = {}, initOverrides) {
        const response = await this.regulatoryAssessmentsControllerGetRegulatoryAssessmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update an existing regulatory assessment
     */
    async regulatoryAssessmentsControllerUpdateRegulatoryAssessmentRaw(requestParameters, initOverrides) {
        if (requestParameters['regulatoryAssessmentAdminDto'] == null) {
            throw new runtime.RequiredError('regulatoryAssessmentAdminDto', 'Required parameter "regulatoryAssessmentAdminDto" was null or undefined when calling regulatoryAssessmentsControllerUpdateRegulatoryAssessment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/regulatory-assessments`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegulatoryAssessmentAdminDtoToJSON)(requestParameters['regulatoryAssessmentAdminDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentAdminDtoFromJSON)(jsonValue));
    }
    /**
     * Update an existing regulatory assessment
     */
    async regulatoryAssessmentsControllerUpdateRegulatoryAssessment(requestParameters, initOverrides) {
        const response = await this.regulatoryAssessmentsControllerUpdateRegulatoryAssessmentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async reliasControllerAssignmentCompletedWebhookRaw(requestParameters, initOverrides) {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError('body', 'Required parameter "body" was null or undefined when calling reliasControllerAssignmentCompletedWebhook().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/relias/assignment-completed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'],
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async reliasControllerAssignmentCompletedWebhook(requestParameters, initOverrides) {
        await this.reliasControllerAssignmentCompletedWebhookRaw(requestParameters, initOverrides);
    }
    /**
     */
    async scheduleControllerGetAvailabilityRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling scheduleControllerGetAvailability().');
        }
        const queryParameters = {};
        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'].toISOString();
        }
        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'].toISOString();
        }
        if (requestParameters['excludeCommittedDates'] != null) {
            queryParameters['excludeCommittedDates'] = requestParameters['excludeCommittedDates'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule/{nurseProfileId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ScheduleAvailabilityDateDtoFromJSON));
    }
    /**
     */
    async scheduleControllerGetAvailability(requestParameters, initOverrides) {
        const response = await this.scheduleControllerGetAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async scheduleControllerSetAvailabilityRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling scheduleControllerSetAvailability().');
        }
        if (requestParameters['updateScheduleAvailabilityDto'] == null) {
            throw new runtime.RequiredError('updateScheduleAvailabilityDto', 'Required parameter "updateScheduleAvailabilityDto" was null or undefined when calling scheduleControllerSetAvailability().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule/{nurseProfileId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.UpdateScheduleAvailabilityDtoToJSON)(requestParameters['updateScheduleAvailabilityDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async scheduleControllerSetAvailability(requestParameters, initOverrides) {
        await this.scheduleControllerSetAvailabilityRaw(requestParameters, initOverrides);
    }
    /**
     */
    async searchControllerFindAvailableOrientationsRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationSearchDto'] == null) {
            throw new runtime.RequiredError('orientationSearchDto', 'Required parameter "orientationSearchDto" was null or undefined when calling searchControllerFindAvailableOrientations().');
        }
        const queryParameters = {};
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/search/orientations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationSearchDtoToJSON)(requestParameters['orientationSearchDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfOrientationSearchResultItemDtoFromJSON)(jsonValue));
    }
    /**
     */
    async searchControllerFindAvailableOrientations(requestParameters, initOverrides) {
        const response = await this.searchControllerFindAvailableOrientationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async searchControllerFindAvailableShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftSearchDto'] == null) {
            throw new runtime.RequiredError('shiftSearchDto', 'Required parameter "shiftSearchDto" was null or undefined when calling searchControllerFindAvailableShifts().');
        }
        const queryParameters = {};
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/search/shifts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftSearchDtoToJSON)(requestParameters['shiftSearchDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfShiftSearchResultItemDtoFromJSON)(jsonValue));
    }
    /**
     */
    async searchControllerFindAvailableShifts(requestParameters, initOverrides) {
        const response = await this.searchControllerFindAvailableShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async searchControllerFindFacilitiesWithinDistanceRaw(requestParameters, initOverrides) {
        if (requestParameters['facilitySearchDto'] == null) {
            throw new runtime.RequiredError('facilitySearchDto', 'Required parameter "facilitySearchDto" was null or undefined when calling searchControllerFindFacilitiesWithinDistance().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/search/facilities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FacilitySearchDtoToJSON)(requestParameters['facilitySearchDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityAbbrDtoFromJSON));
    }
    /**
     */
    async searchControllerFindFacilitiesWithinDistance(requestParameters, initOverrides) {
        const response = await this.searchControllerFindFacilitiesWithinDistanceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async searchControllerGetAvailableOrientationsCountRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationSearchDto'] == null) {
            throw new runtime.RequiredError('orientationSearchDto', 'Required parameter "orientationSearchDto" was null or undefined when calling searchControllerGetAvailableOrientationsCount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/search/orientations/count`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationSearchDtoToJSON)(requestParameters['orientationSearchDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrientationSearchResultsCountDtoFromJSON)(jsonValue));
    }
    /**
     */
    async searchControllerGetAvailableOrientationsCount(requestParameters, initOverrides) {
        const response = await this.searchControllerGetAvailableOrientationsCountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async searchControllerGetAvailableShiftsCountRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftSearchDto'] == null) {
            throw new runtime.RequiredError('shiftSearchDto', 'Required parameter "shiftSearchDto" was null or undefined when calling searchControllerGetAvailableShiftsCount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/search/shifts/count`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftSearchDtoToJSON)(requestParameters['shiftSearchDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftSearchResultsCountDtoFromJSON)(jsonValue));
    }
    /**
     */
    async searchControllerGetAvailableShiftsCount(requestParameters, initOverrides) {
        const response = await this.searchControllerGetAvailableShiftsCountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftControllerAcceptFacilityRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerAcceptFacilityRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerAcceptFacilityRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/accept`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerAcceptFacilityRequest(requestParameters, initOverrides) {
        await this.shiftControllerAcceptFacilityRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerApproveNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerApproveNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerApproveNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/approve`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerApproveNurseRequest(requestParameters, initOverrides) {
        await this.shiftControllerApproveNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerCancelNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerCancelNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerCancelNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/request`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerCancelNurseRequest(requestParameters, initOverrides) {
        await this.shiftControllerCancelNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerCancelShiftAssignmentRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerCancelShiftAssignment().');
        }
        if (requestParameters['nurseShiftCancellationCreateDto'] == null) {
            throw new runtime.RequiredError('nurseShiftCancellationCreateDto', 'Required parameter "nurseShiftCancellationCreateDto" was null or undefined when calling shiftControllerCancelShiftAssignment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/assignment`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NurseShiftCancellationCreateDtoToJSON)(requestParameters['nurseShiftCancellationCreateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerCancelShiftAssignment(requestParameters, initOverrides) {
        await this.shiftControllerCancelShiftAssignmentRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerCancelShiftRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerCancelShiftRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerCancelShiftRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerCancelShiftRequest(requestParameters, initOverrides) {
        await this.shiftControllerCancelShiftRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerClaimShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerClaimShift().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerClaimShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/claim`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerClaimShift(requestParameters, initOverrides) {
        await this.shiftControllerClaimShiftRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerCreateShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftCreateDto'] == null) {
            throw new runtime.RequiredError('shiftCreateDto', 'Required parameter "shiftCreateDto" was null or undefined when calling shiftControllerCreateShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftCreateDtoToJSON)(requestParameters['shiftCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDtoFromJSON)(jsonValue));
    }
    /**
     */
    async shiftControllerCreateShift(requestParameters, initOverrides) {
        const response = await this.shiftControllerCreateShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftControllerDeclineFacilityRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerDeclineFacilityRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerDeclineFacilityRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/decline`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerDeclineFacilityRequest(requestParameters, initOverrides) {
        await this.shiftControllerDeclineFacilityRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerDeclineNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerDeclineNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerDeclineNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/reject`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerDeclineNurseRequest(requestParameters, initOverrides) {
        await this.shiftControllerDeclineNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerDeleteShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerDeleteShift().');
        }
        if (requestParameters['shiftCancellationDto'] == null) {
            throw new runtime.RequiredError('shiftCancellationDto', 'Required parameter "shiftCancellationDto" was null or undefined when calling shiftControllerDeleteShift().');
        }
        const queryParameters = {};
        if (requestParameters['hardDelete'] != null) {
            queryParameters['hardDelete'] = requestParameters['hardDelete'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftCancellationDtoToJSON)(requestParameters['shiftCancellationDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerDeleteShift(requestParameters, initOverrides) {
        await this.shiftControllerDeleteShiftRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerDeleteTimeWorkedRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerDeleteTimeWorked().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/time-worked`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerDeleteTimeWorked(requestParameters, initOverrides) {
        await this.shiftControllerDeleteTimeWorkedRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerDismissDeclinedNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerDismissDeclinedNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerDismissDeclinedNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/dismiss`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerDismissDeclinedNurseRequest(requestParameters, initOverrides) {
        await this.shiftControllerDismissDeclinedNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerListShiftsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['shiftDate'] != null) {
            queryParameters['shiftDate'] = requestParameters['shiftDate'].toISOString();
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'].toISOString();
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'].toISOString();
        }
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['shiftType'] != null) {
            queryParameters['shiftType'] = requestParameters['shiftType'];
        }
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        if (requestParameters['assigned'] != null) {
            queryParameters['assigned'] = requestParameters['assigned'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfShiftListItemDtoFromJSON)(jsonValue));
    }
    /**
     */
    async shiftControllerListShifts(requestParameters = {}, initOverrides) {
        const response = await this.shiftControllerListShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftControllerRequestNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerRequestNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerRequestNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/request`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerRequestNurse(requestParameters, initOverrides) {
        await this.shiftControllerRequestNurseRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerRequestShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerRequestShift().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerRequestShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftControllerRequestShift(requestParameters, initOverrides) {
        await this.shiftControllerRequestShiftRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftControllerSubmitTimeWorkedRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerSubmitTimeWorked().');
        }
        if (requestParameters['submitTimeWorkedDto'] == null) {
            throw new runtime.RequiredError('submitTimeWorkedDto', 'Required parameter "submitTimeWorkedDto" was null or undefined when calling shiftControllerSubmitTimeWorked().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/time-worked`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SubmitTimeWorkedDtoToJSON)(requestParameters['submitTimeWorkedDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftTimeWorkedDtoFromJSON));
    }
    /**
     */
    async shiftControllerSubmitTimeWorked(requestParameters, initOverrides) {
        const response = await this.shiftControllerSubmitTimeWorkedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftControllerUpdateShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerUpdateShift().');
        }
        if (requestParameters['shiftUpdateDto'] == null) {
            throw new runtime.RequiredError('shiftUpdateDto', 'Required parameter "shiftUpdateDto" was null or undefined when calling shiftControllerUpdateShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftUpdateDtoToJSON)(requestParameters['shiftUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDtoFromJSON)(jsonValue));
    }
    /**
     */
    async shiftControllerUpdateShift(requestParameters, initOverrides) {
        const response = await this.shiftControllerUpdateShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftControllerViewShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerViewShift().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDetailsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async shiftControllerViewShift(requestParameters, initOverrides) {
        const response = await this.shiftControllerViewShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all shift matches grouped by profile ID
     */
    async shiftMatchControllerFindAllShiftMatchesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-matches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ProfileShiftMatchesDtoFromJSON));
    }
    /**
     * Get all shift matches grouped by profile ID
     */
    async shiftMatchControllerFindAllShiftMatches(initOverrides) {
        const response = await this.shiftMatchControllerFindAllShiftMatchesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftMatchControllerNotifyProfileOfShiftMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftMatchControllerNotifyProfileOfShiftMatches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-matches/notify/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftMatchControllerNotifyProfileOfShiftMatches(requestParameters, initOverrides) {
        await this.shiftMatchControllerNotifyProfileOfShiftMatchesRaw(requestParameters, initOverrides);
    }
    /**
     */
    async shiftMatchControllerRecordShiftMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['recordShiftMatchesDto'] == null) {
            throw new runtime.RequiredError('recordShiftMatchesDto', 'Required parameter "recordShiftMatchesDto" was null or undefined when calling shiftMatchControllerRecordShiftMatches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-matches`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RecordShiftMatchesDtoToJSON)(requestParameters['recordShiftMatchesDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async shiftMatchControllerRecordShiftMatches(requestParameters, initOverrides) {
        await this.shiftMatchControllerRecordShiftMatchesRaw(requestParameters, initOverrides);
    }
    /**
     * Accept an existing shift proposal
     */
    async shiftProposalControllerAcceptProposalRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftProposalAcceptDto'] == null) {
            throw new runtime.RequiredError('shiftProposalAcceptDto', 'Required parameter "shiftProposalAcceptDto" was null or undefined when calling shiftProposalControllerAcceptProposal().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-proposals/accept`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftProposalAcceptDtoToJSON)(requestParameters['shiftProposalAcceptDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftProposalDtoFromJSON)(jsonValue));
    }
    /**
     * Accept an existing shift proposal
     */
    async shiftProposalControllerAcceptProposal(requestParameters, initOverrides) {
        const response = await this.shiftProposalControllerAcceptProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Cancel an existing shift proposal
     */
    async shiftProposalControllerCancelProposalRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftProposalCancelDto'] == null) {
            throw new runtime.RequiredError('shiftProposalCancelDto', 'Required parameter "shiftProposalCancelDto" was null or undefined when calling shiftProposalControllerCancelProposal().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-proposals`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftProposalCancelDtoToJSON)(requestParameters['shiftProposalCancelDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftProposalDtoFromJSON)(jsonValue));
    }
    /**
     * Cancel an existing shift proposal
     */
    async shiftProposalControllerCancelProposal(requestParameters, initOverrides) {
        const response = await this.shiftProposalControllerCancelProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new shift proposal
     */
    async shiftProposalControllerCreateProposalRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftProposalCreateDto'] == null) {
            throw new runtime.RequiredError('shiftProposalCreateDto', 'Required parameter "shiftProposalCreateDto" was null or undefined when calling shiftProposalControllerCreateProposal().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-proposals`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftProposalCreateDtoToJSON)(requestParameters['shiftProposalCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftProposalDtoFromJSON)(jsonValue));
    }
    /**
     * Create a new shift proposal
     */
    async shiftProposalControllerCreateProposal(requestParameters, initOverrides) {
        const response = await this.shiftProposalControllerCreateProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Reject an existing shift proposal
     */
    async shiftProposalControllerRejectProposalRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftProposalRejectDto'] == null) {
            throw new runtime.RequiredError('shiftProposalRejectDto', 'Required parameter "shiftProposalRejectDto" was null or undefined when calling shiftProposalControllerRejectProposal().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-proposals/reject`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftProposalRejectDtoToJSON)(requestParameters['shiftProposalRejectDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftProposalDtoFromJSON)(jsonValue));
    }
    /**
     * Reject an existing shift proposal
     */
    async shiftProposalControllerRejectProposal(requestParameters, initOverrides) {
        const response = await this.shiftProposalControllerRejectProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftRatingControllerGetFacilityRatingsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftRatingControllerGetFacilityRatings().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating/{shiftId}/facility`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftRatingDtoFromJSON));
    }
    /**
     */
    async shiftRatingControllerGetFacilityRatings(requestParameters, initOverrides) {
        const response = await this.shiftRatingControllerGetFacilityRatingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftRatingControllerGetNurseRatingsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftRatingControllerGetNurseRatings().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating/{shiftId}/nurse`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftRatingDtoFromJSON));
    }
    /**
     */
    async shiftRatingControllerGetNurseRatings(requestParameters, initOverrides) {
        const response = await this.shiftRatingControllerGetNurseRatingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftRatingControllerRateFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftRatingControllerRateFacility().');
        }
        if (requestParameters['shiftRatingCreateDto'] == null) {
            throw new runtime.RequiredError('shiftRatingCreateDto', 'Required parameter "shiftRatingCreateDto" was null or undefined when calling shiftRatingControllerRateFacility().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating/{shiftId}/facility`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftRatingCreateDtoToJSON)(requestParameters['shiftRatingCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftRatingDtoFromJSON));
    }
    /**
     */
    async shiftRatingControllerRateFacility(requestParameters, initOverrides) {
        const response = await this.shiftRatingControllerRateFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftRatingControllerRateNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftRatingControllerRateNurse().');
        }
        if (requestParameters['shiftRatingCreateDto'] == null) {
            throw new runtime.RequiredError('shiftRatingCreateDto', 'Required parameter "shiftRatingCreateDto" was null or undefined when calling shiftRatingControllerRateNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating/{shiftId}/nurse`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftRatingCreateDtoToJSON)(requestParameters['shiftRatingCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftRatingDtoFromJSON));
    }
    /**
     */
    async shiftRatingControllerRateNurse(requestParameters, initOverrides) {
        const response = await this.shiftRatingControllerRateNurseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftRatingMetricControllerGetFacilityMetricsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating-metric/facility`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftRatingMetricQuestionsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async shiftRatingMetricControllerGetFacilityMetrics(initOverrides) {
        const response = await this.shiftRatingMetricControllerGetFacilityMetricsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async shiftRatingMetricControllerGetNurseMetricsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating-metric/nurse`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftRatingMetricQuestionsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async shiftRatingMetricControllerGetNurseMetrics(initOverrides) {
        const response = await this.shiftRatingMetricControllerGetNurseMetricsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async specialtyControllerDeleteProfileSpecialtyRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling specialtyControllerDeleteProfileSpecialty().');
        }
        if (requestParameters['specialtyCode'] == null) {
            throw new runtime.RequiredError('specialtyCode', 'Required parameter "specialtyCode" was null or undefined when calling specialtyControllerDeleteProfileSpecialty().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty/{profileId}/{specialtyCode}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"specialtyCode"}}`, encodeURIComponent(String(requestParameters['specialtyCode']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async specialtyControllerDeleteProfileSpecialty(requestParameters, initOverrides) {
        await this.specialtyControllerDeleteProfileSpecialtyRaw(requestParameters, initOverrides);
    }
    /**
     */
    async specialtyControllerGetAssignableProfileSpecialtiesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling specialtyControllerGetAssignableProfileSpecialties().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty/{profileId}/assignable`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.SpecialtyDtoFromJSON));
    }
    /**
     */
    async specialtyControllerGetAssignableProfileSpecialties(requestParameters, initOverrides) {
        const response = await this.specialtyControllerGetAssignableProfileSpecialtiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async specialtyControllerGetProfileSpecialtiesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling specialtyControllerGetProfileSpecialties().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseSpecialtyDtoFromJSON));
    }
    /**
     */
    async specialtyControllerGetProfileSpecialties(requestParameters, initOverrides) {
        const response = await this.specialtyControllerGetProfileSpecialtiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async specialtyControllerGetSpecialtiesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.SpecialtyDtoFromJSON));
    }
    /**
     */
    async specialtyControllerGetSpecialties(requestParameters = {}, initOverrides) {
        const response = await this.specialtyControllerGetSpecialtiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async specialtyControllerUpdateProfileSpecialtiesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling specialtyControllerUpdateProfileSpecialties().');
        }
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError('requestBody', 'Required parameter "requestBody" was null or undefined when calling specialtyControllerUpdateProfileSpecialties().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseSpecialtyDtoFromJSON));
    }
    /**
     */
    async specialtyControllerUpdateProfileSpecialties(requestParameters, initOverrides) {
        const response = await this.specialtyControllerUpdateProfileSpecialtiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async specialtyControllerUpdateSpecialtyRaw(requestParameters, initOverrides) {
        if (requestParameters['specialtyUpdateDto'] == null) {
            throw new runtime.RequiredError('specialtyUpdateDto', 'Required parameter "specialtyUpdateDto" was null or undefined when calling specialtyControllerUpdateSpecialty().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SpecialtyUpdateDtoToJSON)(requestParameters['specialtyUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.SpecialtyDtoFromJSON)(jsonValue));
    }
    /**
     */
    async specialtyControllerUpdateSpecialty(requestParameters, initOverrides) {
        const response = await this.specialtyControllerUpdateSpecialtyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async stipendControllerAddStipendRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling stipendControllerAddStipend().');
        }
        if (requestParameters['stipendAddDto'] == null) {
            throw new runtime.RequiredError('stipendAddDto', 'Required parameter "stipendAddDto" was null or undefined when calling stipendControllerAddStipend().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/stipend`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.StipendAddDtoToJSON)(requestParameters['stipendAddDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDtoFromJSON)(jsonValue));
    }
    /**
     */
    async stipendControllerAddStipend(requestParameters, initOverrides) {
        const response = await this.stipendControllerAddStipendRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async stipendControllerRemoveStipendRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling stipendControllerRemoveStipend().');
        }
        if (requestParameters['stipendId'] == null) {
            throw new runtime.RequiredError('stipendId', 'Required parameter "stipendId" was null or undefined when calling stipendControllerRemoveStipend().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/stipend/{stipendId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"stipendId"}}`, encodeURIComponent(String(requestParameters['stipendId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDtoFromJSON)(jsonValue));
    }
    /**
     */
    async stipendControllerRemoveStipend(requestParameters, initOverrides) {
        const response = await this.stipendControllerRemoveStipendRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async testDataControllerGenerateTestDataRaw(requestParameters, initOverrides) {
        if (requestParameters['createTestDataDto'] == null) {
            throw new runtime.RequiredError('createTestDataDto', 'Required parameter "createTestDataDto" was null or undefined when calling testDataControllerGenerateTestData().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test-data/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CreateTestDataDtoToJSON)(requestParameters['createTestDataDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.TestDataAvatarsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async testDataControllerGenerateTestData(requestParameters, initOverrides) {
        const response = await this.testDataControllerGenerateTestDataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async tuberculosisScreeningControllerGetQuestionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tuberculosis-screening`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.TuberculosisScreeningDtoFromJSON)(jsonValue));
    }
    /**
     */
    async tuberculosisScreeningControllerGetQuestions(initOverrides) {
        const response = await this.tuberculosisScreeningControllerGetQuestionsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async tuberculosisScreeningControllerGetResponsesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling tuberculosisScreeningControllerGetResponses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tuberculosis-screening/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.TuberculosisScreeningDtoFromJSON)(jsonValue));
    }
    /**
     */
    async tuberculosisScreeningControllerGetResponses(requestParameters, initOverrides) {
        const response = await this.tuberculosisScreeningControllerGetResponsesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async tuberculosisScreeningControllerSubmitResponsesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling tuberculosisScreeningControllerSubmitResponses().');
        }
        if (requestParameters['tuberculosisScreeningCreateDto'] == null) {
            throw new runtime.RequiredError('tuberculosisScreeningCreateDto', 'Required parameter "tuberculosisScreeningCreateDto" was null or undefined when calling tuberculosisScreeningControllerSubmitResponses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tuberculosis-screening/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.TuberculosisScreeningCreateDtoToJSON)(requestParameters['tuberculosisScreeningCreateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async tuberculosisScreeningControllerSubmitResponses(requestParameters, initOverrides) {
        await this.tuberculosisScreeningControllerSubmitResponsesRaw(requestParameters, initOverrides);
    }
    /**
     */
    async typeformControllerHandleHubSpotWebhookRaw(requestParameters, initOverrides) {
        if (requestParameters['typeformPayloadDto'] == null) {
            throw new runtime.RequiredError('typeformPayloadDto', 'Required parameter "typeformPayloadDto" was null or undefined when calling typeformControllerHandleHubSpotWebhook().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/typeform/signup-form/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.TypeformPayloadDtoToJSON)(requestParameters['typeformPayloadDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async typeformControllerHandleHubSpotWebhook(requestParameters, initOverrides) {
        await this.typeformControllerHandleHubSpotWebhookRaw(requestParameters, initOverrides);
    }
    /**
     */
    async vaccinationControllerDeleteVaccinationDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerDeleteVaccinationDocument().');
        }
        if (requestParameters['vaccinationId'] == null) {
            throw new runtime.RequiredError('vaccinationId', 'Required parameter "vaccinationId" was null or undefined when calling vaccinationControllerDeleteVaccinationDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/{vaccinationId}/vaccine-card`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"vaccinationId"}}`, encodeURIComponent(String(requestParameters['vaccinationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async vaccinationControllerDeleteVaccinationDocument(requestParameters, initOverrides) {
        await this.vaccinationControllerDeleteVaccinationDocumentRaw(requestParameters, initOverrides);
    }
    /**
     */
    async vaccinationControllerGetVaccinationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerGetVaccination().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling vaccinationControllerGetVaccination().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/{code}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.VaccinationDtoFromJSON)(jsonValue));
    }
    /**
     */
    async vaccinationControllerGetVaccination(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerGetVaccinationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async vaccinationControllerGetVaccinationDeclinationAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerGetVaccinationDeclinationAgreement().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling vaccinationControllerGetVaccinationDeclinationAgreement().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/{code}/declination`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.VaccineDeclinationDtoFromJSON)(jsonValue));
    }
    /**
     */
    async vaccinationControllerGetVaccinationDeclinationAgreement(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerGetVaccinationDeclinationAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async vaccinationControllerGetVaccinationsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerGetVaccinations().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.VaccinationDtoFromJSON));
    }
    /**
     */
    async vaccinationControllerGetVaccinations(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerGetVaccinationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async vaccinationControllerIngestVaccinationDocumentationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerIngestVaccinationDocumentation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document']);
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/ingest`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.IngestedVaccinationRecordsDtoFromJSON)(jsonValue));
    }
    /**
     */
    async vaccinationControllerIngestVaccinationDocumentation(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerIngestVaccinationDocumentationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async vaccinationControllerSignVaccinationDeclinationAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerSignVaccinationDeclinationAgreement().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling vaccinationControllerSignVaccinationDeclinationAgreement().');
        }
        if (requestParameters['signVaccineDeclinationAgreementDto'] == null) {
            throw new runtime.RequiredError('signVaccineDeclinationAgreementDto', 'Required parameter "signVaccineDeclinationAgreementDto" was null or undefined when calling vaccinationControllerSignVaccinationDeclinationAgreement().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/{code}/declination`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SignVaccineDeclinationAgreementDtoToJSON)(requestParameters['signVaccineDeclinationAgreementDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.VaccineDeclinationDtoFromJSON)(jsonValue));
    }
    /**
     */
    async vaccinationControllerSignVaccinationDeclinationAgreement(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerSignVaccinationDeclinationAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async vaccinationControllerUpdateVaccinationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerUpdateVaccination().');
        }
        if (requestParameters['vaccinationDto'] == null) {
            throw new runtime.RequiredError('vaccinationDto', 'Required parameter "vaccinationDto" was null or undefined when calling vaccinationControllerUpdateVaccination().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.VaccinationDtoToJSON)(requestParameters['vaccinationDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.VaccinationDtoFromJSON)(jsonValue));
    }
    /**
     */
    async vaccinationControllerUpdateVaccination(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerUpdateVaccinationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async vaccinationControllerUploadVaccinationCardRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerUploadVaccinationCard().');
        }
        if (requestParameters['vaccinationId'] == null) {
            throw new runtime.RequiredError('vaccinationId', 'Required parameter "vaccinationId" was null or undefined when calling vaccinationControllerUploadVaccinationCard().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['vaccineCard'] != null) {
            formParams.append('vaccineCard', requestParameters['vaccineCard']);
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/{vaccinationId}/vaccine-card`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"vaccinationId"}}`, encodeURIComponent(String(requestParameters['vaccinationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async vaccinationControllerUploadVaccinationCard(requestParameters, initOverrides) {
        await this.vaccinationControllerUploadVaccinationCardRaw(requestParameters, initOverrides);
    }
    /**
     */
    async webhookControllerHandleCheckrWebhookRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/background-check/webhook/checkr`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async webhookControllerHandleCheckrWebhook(initOverrides) {
        await this.webhookControllerHandleCheckrWebhookRaw(initOverrides);
    }
    /**
     */
    async webhookControllerIncomingMessageRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/sms/webhook/incoming`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async webhookControllerIncomingMessage(initOverrides) {
        await this.webhookControllerIncomingMessageRaw(initOverrides);
    }
    /**
     */
    async workQualificationControllerGetOrientationQualificationsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftCandidatesDto'] == null) {
            throw new runtime.RequiredError('shiftCandidatesDto', 'Required parameter "shiftCandidatesDto" was null or undefined when calling workQualificationControllerGetOrientationQualifications().');
        }
        const queryParameters = {};
        if (requestParameters['nurseProfileId'] != null) {
            queryParameters['nurseProfileId'] = requestParameters['nurseProfileId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/work-qualification/orientation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftCandidatesDtoToJSON)(requestParameters['shiftCandidatesDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorkQualificationResultDtoFromJSON)(jsonValue));
    }
    /**
     */
    async workQualificationControllerGetOrientationQualifications(requestParameters, initOverrides) {
        const response = await this.workQualificationControllerGetOrientationQualificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async workQualificationControllerGetShiftQualificationsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftCandidatesDto'] == null) {
            throw new runtime.RequiredError('shiftCandidatesDto', 'Required parameter "shiftCandidatesDto" was null or undefined when calling workQualificationControllerGetShiftQualifications().');
        }
        const queryParameters = {};
        if (requestParameters['nurseProfileId'] != null) {
            queryParameters['nurseProfileId'] = requestParameters['nurseProfileId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/work-qualification/shift`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftCandidatesDtoToJSON)(requestParameters['shiftCandidatesDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorkQualificationResultDtoFromJSON)(jsonValue));
    }
    /**
     */
    async workQualificationControllerGetShiftQualifications(requestParameters, initOverrides) {
        const response = await this.workQualificationControllerGetShiftQualificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.DefaultApi = DefaultApi;
/**
 * @export
 */
exports.FacilityControllerListOrientationsStatusEnum = {
    Open: 'open',
    Upcoming: 'upcoming',
    Complete: 'complete',
    Canceled: 'canceled',
    All: 'all'
};
/**
 * @export
 */
exports.FacilityControllerListOrientationsSortEnum = {
    OpenSeatsAsc: 'openSeats:asc',
    OpenSeatsDesc: 'openSeats:desc',
    OpenSeats: 'openSeats',
    PostedByAsc: 'postedBy:asc',
    PostedByDesc: 'postedBy:desc',
    PostedBy: 'postedBy',
    LicenseTypeAsc: 'licenseType:asc',
    LicenseTypeDesc: 'licenseType:desc',
    LicenseType: 'licenseType',
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime',
    TotalSeatsAsc: 'totalSeats:asc',
    TotalSeatsDesc: 'totalSeats:desc',
    TotalSeats: 'totalSeats',
    SpecialtyCodeAsc: 'specialtyCode:asc',
    SpecialtyCodeDesc: 'specialtyCode:desc',
    SpecialtyCode: 'specialtyCode',
    CreatedAtAsc: 'createdAt:asc',
    CreatedAtDesc: 'createdAt:desc',
    CreatedAt: 'createdAt'
};
/**
 * @export
 */
exports.FacilityControllerListShiftsStatusEnum = {
    Open: 'open',
    Upcoming: 'upcoming',
    Complete: 'complete',
    Canceled: 'canceled',
    All: 'all'
};
/**
 * @export
 */
exports.FacilityControllerListShiftsShiftTimesEnum = {
    Days06001830: 'DAYS_0600_1830',
    Days07001100: 'DAYS_0700_1100',
    Days07001530: 'DAYS_0700_1530',
    Days07001930: 'DAYS_0700_1930',
    Days11001500: 'DAYS_1100_1500',
    Eves15001900: 'EVES_1500_1900',
    Eves15002330: 'EVES_1500_2330',
    Eves19002300: 'EVES_1900_2300',
    Nights03000700: 'NIGHTS_0300_0700',
    Nights18000630: 'NIGHTS_1800_0630',
    Nights19000730: 'NIGHTS_1900_0730',
    Nights23000300: 'NIGHTS_2300_0300',
    Nights23000730: 'NIGHTS_2300_0730',
    Custom: 'CUSTOM'
};
/**
 * @export
 */
exports.FacilityControllerListShiftsShiftTypeEnum = {
    Clinical: 'CLINICAL',
    Orientation: 'ORIENTATION',
    OnCall: 'ON_CALL'
};
/**
 * @export
 */
exports.FacilityControllerListShiftsSortEnum = {
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime',
    EndTimeAsc: 'endTime:asc',
    EndTimeDesc: 'endTime:desc',
    EndTime: 'endTime',
    LicenseTypeAsc: 'licenseType:asc',
    LicenseTypeDesc: 'licenseType:desc',
    LicenseType: 'licenseType',
    NurseProfileAsc: 'nurseProfile:asc',
    NurseProfileDesc: 'nurseProfile:desc',
    NurseProfile: 'nurseProfile',
    ShiftTimeAsc: 'shiftTime:asc',
    ShiftTimeDesc: 'shiftTime:desc',
    ShiftTime: 'shiftTime',
    PostedByAsc: 'postedBy:asc',
    PostedByDesc: 'postedBy:desc',
    PostedBy: 'postedBy',
    SpecialtyAsc: 'specialty:asc',
    SpecialtyDesc: 'specialty:desc',
    Specialty: 'specialty',
    CreatedAtAsc: 'createdAt:asc',
    CreatedAtDesc: 'createdAt:desc',
    CreatedAt: 'createdAt'
};
/**
 * @export
 */
exports.FacilityControllerOrientationCalendarSortEnum = {
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime'
};
/**
 * @export
 */
exports.FacilityControllerShiftCalendarSortEnum = {
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime'
};
/**
 * @export
 */
exports.NurseControllerListOrientationsSortEnum = {
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime'
};
/**
 * @export
 */
exports.NurseControllerListShiftsSortEnum = {
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime'
};
/**
 * @export
 */
exports.PayrollControllerGetPaychecksStatusEnum = {
    Pending: 'PENDING',
    Preprocessed: 'PREPROCESSED',
    Processed: 'PROCESSED',
    Voided: 'VOIDED',
    Failed: 'FAILED'
};
/**
 * @export
 */
exports.SearchControllerFindAvailableOrientationsSortEnum = {
    PayRateAsc: 'payRate:asc',
    PayRateDesc: 'payRate:desc',
    PayRate: 'payRate',
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime'
};
/**
 * @export
 */
exports.SearchControllerFindAvailableShiftsSortEnum = {
    PayRateAsc: 'payRate:asc',
    PayRateDesc: 'payRate:desc',
    PayRate: 'payRate',
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime'
};
/**
 * @export
 */
exports.ShiftControllerListShiftsStatusEnum = {
    Active: 'ACTIVE',
    Canceled: 'CANCELED'
};
/**
 * @export
 */
exports.ShiftControllerListShiftsShiftTypeEnum = {
    Clinical: 'CLINICAL',
    Orientation: 'ORIENTATION',
    OnCall: 'ON_CALL'
};
/**
 * @export
 */
exports.ShiftControllerListShiftsSortEnum = {
    FacilityAsc: 'facility:asc',
    FacilityDesc: 'facility:desc',
    Facility: 'facility',
    NurseProfileAsc: 'nurseProfile:asc',
    NurseProfileDesc: 'nurseProfile:desc',
    NurseProfile: 'nurseProfile',
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime',
    SpecialtyCodeAsc: 'specialtyCode:asc',
    SpecialtyCodeDesc: 'specialtyCode:desc',
    SpecialtyCode: 'specialtyCode',
    StatusAsc: 'status:asc',
    StatusDesc: 'status:desc',
    Status: 'status',
    TotalRateAsc: 'totalRate:asc',
    TotalRateDesc: 'totalRate:desc',
    TotalRate: 'totalRate'
};
//# sourceMappingURL=DefaultApi.js.map